import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import data from "../../../../assets/apiRoutes.json";
import ArrayStore from 'devextreme/data/array_store';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import FormField from '../../../../dynamicFormBuilder/FormField'
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { PrimaryLayout } from './PrimaryLayout';
import { RepackLayout } from './RepackLayout';
import { MiscellaneousTabLayout } from './MiscellaneousTabLayout';
import { PrintFormatTabLayout } from './PrintFormatTabLayout';
import Toast from 'devextreme/ui/toast';
import { DetailsLayout } from "./DetailsLayout";
import { HeaderTabLayout } from "./HeaderTabLayout";

var skipDataLoading = false;
var isTransactionExist = false;
let navrpt1name = "";
let navrpt2name = "";
let navrpt3name = "";
let navrpt4name = "";
function PrimaryTab(props) {
    const [dialogVisible, setDialogVisible] = useState(false);
    const [selectionPriority, setSelectionPriority] = useState(1);
    const openDialog = async () => {
        setDialogVisible(true);
    };
    const closeDialog = () => {
        setDialogVisible(false);
    };
    const LOCATIONPICKMETHOD_SHIPMENTS = [
        { id: 'L', name: 'Location Code' },
        { id: 'P', name: 'Priority Code' },
        { id: 'C', name: 'Class Code' },
        { id: 'S', name: 'Sub Class Code' }
    ]
    const LOCATIONPICKMETHOD_SHIPMENTS_2 = [
        { id: 'F', name: 'Items Forward Pick Location' },
        { id: 'R', name: 'Items Replenishment Location' },
        { id: 'S', name: 'Items Reserve Location' }
    ]
    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        KEYSEQUENCE: 1,
        RECORDNO: '',
        PROFILECODE: '',
        DESCRIPTION: '',
        COMMENT: '',
        POPUPMESSAGE: '',
        USERDEFINEDCODE_1: '',
        USERDEFINEDCODE_2: '',
        USERDEFINEDCODE_3: '',
        USERDEFINEDCODE_4: '',
        USERDEFINEDCODE_5: '',
        R_REPACKSHIPMENT_PROFILE: '',
        REPACKUPDATEMODE: '',
        REPACKDELETEMODE: '',
        MODULE: 'WM',
        REPACKDELETEMODE: '',
        RF_SERIALNUMBERHANDLING: 'N',
        R_CAACTIVITY_UNLOADBY: '',
        UNLOADBYDescription: '',
        R_CAACTIVITY_PUTAWAYBY: '',
        R_CAACTIVITY_PUTAWAYBY_Des: '',
        R_CAACTIVITY_CHECKBY: '',
        R_CAACTIVITY_CHECKBY_Des: '',
        R_CAACTIVITY_PICKBY: '',
        R_CAACTIVITY_PICKBY_Des: '',
        R_CAACTIVITY_LOADBY: '',
        R_CAACTIVITY_LOADBY_Des: '',
        RFGROUP_PARTIALQTY: '',
        RFGROUP_FULLQTY: '',
        AUTOGENERATESERIALNUMBER: 'N',
        USECRATE: 'N',
        SHOWSERIALNOPOPUP: '',
        SUBLOT_ALTERNATEIDMETHOD: 'N',
        SCREENTOTALS: 'A',
        TRANSLOCWEIGHT: 'N',
        ESITMATEDWEIGHT: 'N',
        GENERATEINSPECTION: 'N',
        WORKUNITUOM: '',
        PROCESSDYNEVALCHARGES: 'N',
        RECEIPTCOMMITORDEREDACTUAL: 'N',
        OTCREATEITEMFLAG: 'N',
        LOTCODEENTRYMETHOD: 'N',
        OVERSELLINGWARNING: 'N',
        SUBLOTVERIFICATION: '',
        ALLOWITEMDETAILS: 'N',
        ISTRANSACTIONHEADERRECORDEXIST: false,
        PRINTEDITREPORT: '',
        PRINTBOLFORMAT: '',
        PRINTBOLFORMAT_SIMPLE: '',
        PRINTBOLFORMAT_SPECIAL: '',
        PRINTPICKINGSLIPFORMAT: '',
        PRINTSHIPPINGLABEL: '',
        PRINTSERIALNUMBERLABEL: '',
        PRINTSSCCLABEL: '',
        PRINTPICKINGSLIPSEQUENCE: '',
        PRINTSERIALNOMANIFESTREV: '',
        PRINTPUTAWAY: '',
        PRINTRECEIVINGLABEL: '',
        PRINTRECEIPTCONFIRMATION: '',
        NAVREPORT1STATUS: 'I',
        NAVREPORT1TEXT: '',
        NAVREPORT1TYPE: '',
        NAVREPORT1NAME: '',
        NAVREPORT1FORMAT: '',

        NAVREPORT2STATUS: 'I',
        NAVREPORT2TEXT: '',
        NAVREPORT2TYPE: '',
        NAVREPORT2NAME: '',
        NAVREPORT2FORMAT: '',

        NAVREPORT3STATUS: 'I',
        NAVREPORT3TEXT: '',
        NAVREPORT3TYPE: '',
        NAVREPORT3NAME: '',
        NAVREPORT3FORMAT: '',

        NAVREPORT4STATUS: 'I',
        NAVREPORT4TEXT: '',
        NAVREPORT4TYPE: '',
        NAVREPORT4NAME: '',
        NAVREPORT4FORMAT: '',

        R_WAREHOUSE: '',
        USELOCATION: '',
        ALLOWBLANKLOCATIONS: '',
        LOCATIONBYCLASS: '',
        RECEIVINGMETHOD_LOT: '',
        RECEIVINGMETHOD_SUBLOT: '',
        RECEIVINGMETHOD_UNIT: '',
        LOCATIONMETHOD_RECEIPTS: '',
        SHOWMASTER_LOT: '',
        SHOWMASTER_SUBLOT: '',
        SHOWMASTER_UNIT: '',
        SHIPMENTSONNEG_AVL: '',
        IGNORESAMEDAYSHIPTIME: '',
        SHIPMENTSONNET_AVL: '',
        SHIPMENTQTYCHKONDTLSAVE: '',
        LOTMETHOD_SHIPMENTS: '',
        SUBLOTMETHOD_SHIPMENTS: '',
        UNITMETHOD_SHIPMENTS: '',
        LOCATIONMETHOD_SHIPMENTS: '',
        LOTPICKMETHOD_SHIPMENTS: '',
        SUBLOTPICKMETHOD_SHIPMENTS: '',
        UNITPICKMETHOD_SHIPMENTS: '',
        LOCATIONPICKMETHOD_SHIPMENTS: '',
        LOTPICKSEQUENCE_SHIPMENTS: '',
        SUBLOTPICKSEQUENCE_SHIPMENTS: '',
        UNITPICKSEQUENCE_SHIPMENTS: '',
        LOCATIONPICKSEQUENCE_SHIPMENTS: '',
        DEFAULTITEMLOTMANAGEMENTUNIT: '',
        POPULATELOTWITHCARRIER: '',
        LOTSTORAGEDATE: '',
        LOTAVAILABLEDATE: '',
        DUPLICATELOT: '',
        DUPLICATESUBLOT: '',
        UPDATEUDFIELDS: '',
        DETAILUDFIELDS: '',
        REASONMANDATORY: '',
        USEONESSCCPERTRANS: '',
        STATUS: 'A',
        SHOWSHIPPERONRECEIPT: 'Y',
        MODIFYCOMMITTEDTRANS: 'N',
        DELETERECEIPTS: 'B',
        ACCESSRATESCHEDULE: 'N',
        DATEVALIDATION: '',
        LIMITCONSIGNEELOOKUP: 'N',
        RFTRANSACTION: '',

        TRANSNOGENERATION_RECEIPT: 'A',
        TRANSNOGENERATION_SHIPMENT: 'A',
        TRANSNOGENERATION_ADJUSTMENT: 'A',
        TRANSACTIONPREFIX: '',
        POPULATEACTUALRSDATE: 'C',
        CREATEFMCONTENTS: 'N',
        FMPICKUPDATE: 'R',
        FROMSTAGE_FMTRANSFER: 'C',
        FMTRANSACTIONNUMBER: 'A',
        TRANSFERTOCOMPANYID: '',
        VALIDATEINVOICESETUP: 'W',
        ALLOWUSERVALIDATION: 'N',
        POPUPMESSAGEUSER: '',
        ISPLACEHOLDERRECORD: 'N',
        LOTEXPIRATIONDATECHECK: '',
        ALLOWDUPLICATEPO: 'N',
        DUPLICATETRAILERCARRIER: 'Y',
        DUPLICATESHIPPERBOLNUMBER: 'Y',
        VALIDATEACTRECSHIPDT: 'N',
        ACTRECSHIPDTDAYSBEHIND: '',
        ACTRECSHIPDTDAYSAHEAD: '',
        SPLITORDER: 'N',
        SPLITORDERSOURCEFIELD: 'T',
        PLANDATETIMEDEFAULT: 'N',
        STAGINGDATETIMEDEFAULT: 'N',
        CREDITCHECKONSTAGECHANGE : 'N',
        USERVALIDATIONONCOMMIT : 'N'
    };

    const [formFields, setformFields] = useState(initialFormFields);
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});

    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            console.log(formFields);
            if (formFields.ROWID == "00000000-0000-0000-0000-000000000000") {
                await postTransaction();
            }
            else {
                await updateTransaction();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const handleChangeDimensionButtonClick = async (selectionPriority) => {
        if (formFields.ROWID == "00000000-0000-0000-0000-000000000000") {
            await postTransaction();
        }
        else {
            await updateTransaction();
        }
        closeDialog();
    };
    const postTransaction = async () => {
        try {
            const url = "wm/TransactionDataProfile/PostTransaction";
            let fields = formFields;
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.data.issuccess) {

                setformFields(prevFields => ({
                    ...prevFields,
                    ROWID: response.data.rowid,
                    RECORDNO: response.data.recordno,
                }));

                notify(
                    {
                        message: "Transaction Profile Created",
                        width: 600,
                    },
                    'success',
                    3000,
                );
                //(false);
            } else {
                notify(
                    {
                        message: response.data.message,
                        width: 100,
                    },
                    'error',
                    3000,
                );
                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateTransaction = async () => {
        try {
            const url = "wm/TransactionDataProfile/PutTransaction";
            let fields = formFields;
            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.data.issuccess) {

                notify(
                    {
                        message: "Transaction Profile Updated",
                        width: 600,
                    },
                    'success',
                    3000,
                );

            } else {
                notify(
                    {
                        message: response.data.message,
                        width: 100,
                    },
                    'error',
                    3000,
                );
                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const loadLookupClient = (name, data) => {

        try {
            const newOptions = data.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            if (formRefs.current[name]) {

                formRefs.current[name].instance().option('dataSource', newOptions);
                formRefs.current[name].instance().option('valueExpr', 'id');
                formRefs.current[name].instance().option('displayExpr', 'name');
            }

        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
        }
    };
    const loadLookupClientByName = (name, data) => {

        try {
            const newOptions = data.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            if (formRefs.current[name]) {

                formRefs.current[name].instance().option('dataSource', newOptions);
                formRefs.current[name].instance().option('valueExpr', 'name');
                formRefs.current[name].instance().option('displayExpr', 'name');
            }

        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
        }
    };
    const loadLookupFromDataSource = (name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
        }
        else {
            console.log('not found control:');
        }
    };
    const loadLookupFromDataSourceName = (name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'name');
            formRefs.current[name].instance().option('displayExpr', 'name');
        }
        else {
            console.log('not found control:');
        }
    };
    const handleReset = () => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableControlsForNewRecord();
        }
    };
    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            const response = axios.get(`${window._env_.REACT_APP_APIS}/wm/TransactionDataProfile/GetByRowId?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {

                const responseData = res.data;
                console.log(responseData)
                if (responseData.ROWID) {
                    skipDataLoading = true;
                    isTransactionExist = responseData.isTransactionExist;
                    setformFields(responseData);
                    skipDataLoading = false;

                    navrpt1name = responseData.NAVREPORT1NAME;
                    navrpt2name = responseData.NAVREPORT2NAME;
                    navrpt3name = responseData.NAVREPORT3NAME;
                    navrpt4name = responseData.NAVREPORT4NAME;
                    if (responseData.NAVREPORT1STATUS == 'I') {
                        if (formRefs.current['NAVREPORT1TEXT']) {
                            formRefs.current['NAVREPORT1TEXT'].instance().option('disabled', true);
                        }
                        if (formRefs.current['NAVREPORT1TYPE']) {
                            formRefs.current['NAVREPORT1TYPE'].instance().option('disabled', true);
                        }
                        if (formRefs.current['NAVREPORT1NAME']) {
                            formRefs.current['NAVREPORT1NAME'].instance().option('disabled', true);
                        }
                        if (formRefs.current['NAVREPORT1FORMAT']) {
                            formRefs.current['NAVREPORT1FORMAT'].instance().option('disabled', true);
                        }
                    } else if (responseData.NAVREPORT1STATUS == 'A') {
                        if (formRefs.current['NAVREPORT1TEXT']) {
                            formRefs.current['NAVREPORT1TEXT'].instance().option('disabled', false);
                        }
                        if (formRefs.current['NAVREPORT1TYPE']) {
                            formRefs.current['NAVREPORT1TYPE'].instance().option('disabled', false);
                        }
                        if (formRefs.current['NAVREPORT1NAME']) {
                            formRefs.current['NAVREPORT1NAME'].instance().option('disabled', false);
                        }
                        if (formRefs.current['NAVREPORT1FORMAT']) {
                            formRefs.current['NAVREPORT1FORMAT'].instance().option('disabled', false);
                        }
                    }

                    if (responseData.NAVREPORT2STATUS == 'I') {
                        if (formRefs.current['NAVREPORT2TEXT']) {
                            formRefs.current['NAVREPORT2TEXT'].instance().option('disabled', true);
                        }
                        if (formRefs.current['NAVREPORT2TYPE']) {
                            formRefs.current['NAVREPORT2TYPE'].instance().option('disabled', true);
                        }
                        if (formRefs.current['NAVREPORT2NAME']) {
                            formRefs.current['NAVREPORT2NAME'].instance().option('disabled', true);
                        }
                        if (formRefs.current['NAVREPORT2FORMAT']) {
                            formRefs.current['NAVREPORT2FORMAT'].instance().option('disabled', true);
                        }
                    } else if (responseData.NAVREPORT2STATUS == 'A') {
                        if (formRefs.current['NAVREPORT2TEXT']) {
                            formRefs.current['NAVREPORT2TEXT'].instance().option('disabled', false);
                        }
                        if (formRefs.current['NAVREPORT2TYPE']) {
                            formRefs.current['NAVREPORT2TYPE'].instance().option('disabled', false);
                        }
                        if (formRefs.current['NAVREPORT2NAME']) {
                            formRefs.current['NAVREPORT2NAME'].instance().option('disabled', false);
                        }
                        if (formRefs.current['NAVREPORT2FORMAT']) {
                            formRefs.current['NAVREPORT2FORMAT'].instance().option('disabled', false);
                        }
                    }

                    if (responseData.NAVREPORT3STATUS == 'I') {
                        if (formRefs.current['NAVREPORT3TEXT']) {
                            formRefs.current['NAVREPORT3TEXT'].instance().option('disabled', true);
                        }
                        if (formRefs.current['NAVREPORT3TYPE']) {
                            formRefs.current['NAVREPORT3TYPE'].instance().option('disabled', true);
                        }
                        if (formRefs.current['NAVREPORT3NAME']) {
                            formRefs.current['NAVREPORT3NAME'].instance().option('disabled', true);
                        }
                        if (formRefs.current['NAVREPORT3FORMAT']) {
                            formRefs.current['NAVREPORT3FORMAT'].instance().option('disabled', true);
                        }
                    } else if (responseData.NAVREPORT3STATUS == 'A') {
                        if (formRefs.current['NAVREPORT3TEXT']) {
                            formRefs.current['NAVREPORT3TEXT'].instance().option('disabled', false);
                        }
                        if (formRefs.current['NAVREPORT3TYPE']) {
                            formRefs.current['NAVREPORT3TYPE'].instance().option('disabled', false);
                        }
                        if (formRefs.current['NAVREPORT3NAME']) {
                            formRefs.current['NAVREPORT3NAME'].instance().option('disabled', false);
                        }
                        if (formRefs.current['NAVREPORT3FORMAT']) {
                            formRefs.current['NAVREPORT3FORMAT'].instance().option('disabled', false);
                        }
                    }

                    if (responseData.NAVREPORT4STATUS == 'I') {
                        if (formRefs.current['NAVREPORT4TEXT']) {
                            formRefs.current['NAVREPORT4TEXT'].instance().option('disabled', true);
                        }
                        if (formRefs.current['NAVREPORT4TYPE']) {
                            formRefs.current['NAVREPORT4TYPE'].instance().option('disabled', true);
                        }
                        if (formRefs.current['NAVREPORT4NAME']) {
                            formRefs.current['NAVREPORT4NAME'].instance().option('disabled', true);
                        }
                        if (formRefs.current['NAVREPORT4FORMAT']) {
                            formRefs.current['NAVREPORT4FORMAT'].instance().option('disabled', true);
                        }
                    } else if (responseData.NAVREPORT4STATUS == 'A') {
                        if (formRefs.current['NAVREPORT4TEXT']) {
                            formRefs.current['NAVREPORT4TEXT'].instance().option('disabled', false);
                        }
                        if (formRefs.current['NAVREPORT4TYPE']) {
                            formRefs.current['NAVREPORT4TYPE'].instance().option('disabled', false);
                        }
                        if (formRefs.current['NAVREPORT4NAME']) {
                            formRefs.current['NAVREPORT4NAME'].instance().option('disabled', false);
                        }
                        if (formRefs.current['NAVREPORT4FORMAT']) {
                            formRefs.current['NAVREPORT4FORMAT'].instance().option('disabled', false);
                        }
                    }

                }
                else {
                    console.error('Failed to get transaction data');
                }
            });


        } catch (error) {
            console.error('Error failed to get transaction data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const EnableControlsForNewRecord = () => {
        setformFields(prevFields => ({
            ...prevFields,
            R_WAREHOUSE: '',
            USELOCATION: 'Y',
            ALLOWBLANKLOCATIONS: 'N',
            LOCATIONBYCLASS: 'Y',
            RECEIVINGMETHOD_LOT: 'M',
            RECEIVINGMETHOD_SUBLOT: 'M',
            RECEIVINGMETHOD_UNIT: 'M',
            LOCATIONMETHOD_RECEIPTS: 'W',
            SHOWMASTER_LOT: 'N',
            SHOWMASTER_SUBLOT: 'N',
            SHOWMASTER_UNIT: 'N',
            SHIPMENTSONNEG_AVL: 'N',
            IGNORESAMEDAYSHIPTIME: 'N',
            SHIPMENTSONNET_AVL: 'Y',
            SHIPMENTQTYCHKONDTLSAVE: 'N',
            LOTMETHOD_SHIPMENTS: 'M',
            SUBLOTMETHOD_SHIPMENTS: 'M',
            UNITMETHOD_SHIPMENTS: 'M',
            LOCATIONMETHOD_SHIPMENTS: 'M',
            LOTPICKMETHOD_SHIPMENTS: 'L',
            SUBLOTPICKMETHOD_SHIPMENTS: 'S',
            UNITPICKMETHOD_SHIPMENTS: 'U',
            LOCATIONPICKMETHOD_SHIPMENTS: 'A',
            LOTPICKSEQUENCE_SHIPMENTS: 'A',
            SUBLOTPICKSEQUENCE_SHIPMENTS: 'A',
            UNITPICKSEQUENCE_SHIPMENTS: 'A',
            LOCATIONPICKSEQUENCE_SHIPMENTS: 'A',
            DEFAULTITEMLOTMANAGEMENTUNIT: 'M',
            POPULATELOTWITHCARRIER: 'N',
            LOTSTORAGEDATE: 'Y',
            LOTAVAILABLEDATE: 'N',
            DUPLICATELOT: 'Y',
            DUPLICATESUBLOT: 'Y',
            UPDATEUDFIELDS: 'N',
            DETAILUDFIELDS: 'N',
            REASONMANDATORY: '',
            USEONESSCCPERTRANS: ''
        }))
    }
    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            EnableControlsForNewRecord();
        }
    }, [props.id]);
    const goBack = () => {
        history.push("/wm/DataProfiles/SearchTransactionProfiles");
    };
    const goToDefaultTransaction = () => {
        if (isTransactionExist) {
            history.push("/wm/transactiondataentry/edit-transaction?id=" + formFields.ROWID + "&recordType=P");
        } else {
            history.push("/wm/transactiondataentry/create-transaction?recordType=P");
        }
    };

    const loadLookupDataSource = (formRefs, name, url, valueExpr, displayExpr, loadParams = null) => {
        var dataSource = new DataSource({
            store: new createStore({
                key: valueExpr,
                loadUrl: url,
                loadParams: loadParams,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: displayExpr, desc: false }],
            paginate: true,
            pageSize: 100
        });
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }
    };
    const handleFieldChange = useCallback((name, value, e) => {

    }, []);
    const handleSelectionChange = useCallback((name, e) => {
        if (name == 'NAVREPORT1TYPE') {
            setformFields(prevFields => ({
                ...prevFields,
                NAVREPORT1NAME: '',
                NAVREPORT1FORMAT: '',
            }));
            formRefs.current['NAVREPORT1NAME'].instance().option('value', null);  
            formRefs.current['NAVREPORT1FORMAT'].instance().option('value', null);  
        }
        if (name == 'NAVREPORT2TYPE') {
            setformFields(prevFields => ({
                ...prevFields,
                NAVREPORT2NAME: '',
                NAVREPORT2FORMAT: '',
            }));
            formRefs.current['NAVREPORT2NAME'].instance().option('value', null);  
            formRefs.current['NAVREPORT2FORMAT'].instance().option('value', null);  
        }
        if (name == 'NAVREPORT3TYPE') {
            setformFields(prevFields => ({
                ...prevFields,
                NAVREPORT3NAME: '',
                NAVREPORT3FORMAT: '',
            }));
            formRefs.current['NAVREPORT3NAME'].instance().option('value', null);  
            formRefs.current['NAVREPORT3FORMAT'].instance().option('value', null);  
        }
        if (name == 'NAVREPORT4TYPE') {
            setformFields(prevFields => ({
                ...prevFields,
                NAVREPORT4NAME: '',
                NAVREPORT4FORMAT: '',
            }));
            formRefs.current['NAVREPORT4NAME'].instance().option('value', null);  
            formRefs.current['NAVREPORT4FORMAT'].instance().option('value', null);  
        }
        if (name == 'R_CAACTIVITY_UNLOADBY') {
            setformFields(prevFields => ({
                ...prevFields,
                UNLOADBYDescription: e?.selectedItem?.description,
            }));
        }
        if (name == 'R_CAACTIVITY_PUTAWAYBY') {
            setformFields(prevFields => ({
                ...prevFields,
                R_CAACTIVITY_PUTAWAYBY_Des: e?.selectedItem?.description,
            }));
        }
        if (name == 'R_CAACTIVITY_CHECKBY') {
            setformFields(prevFields => ({
                ...prevFields,
                R_CAACTIVITY_CHECKBY_Des: e?.selectedItem?.description,
            }));
        }
        if (name == 'R_CAACTIVITY_PICKBY') {
            setformFields(prevFields => ({
                ...prevFields,
                R_CAACTIVITY_PICKBY_Des: e?.selectedItem?.description,
            }));
        }
        if (name == 'R_CAACTIVITY_LOADBY') {
            setformFields(prevFields => ({
                ...prevFields,
                R_CAACTIVITY_LOADBY_Des: e?.selectedItem?.description,
            }));
        }
        if (name == 'VALIDATEACTRECSHIPDT') {
            if (e.selectedItem.id === 'N') {
                formRefs.current['ACTRECSHIPDTDAYSBEHIND'].instance().option('disabled', true);
                formRefs.current['ACTRECSHIPDTDAYSBEHIND'].instance().option('value', null);  
                formRefs.current['ACTRECSHIPDTDAYSAHEAD'].instance().option('disabled', true);
                formRefs.current['ACTRECSHIPDTDAYSAHEAD'].instance().option('value', null);  
            }
            else {
                formRefs.current['ACTRECSHIPDTDAYSBEHIND'].instance().option('disabled', false);
                formRefs.current['ACTRECSHIPDTDAYSAHEAD'].instance().option('disabled', false);
            }
        }
        if (name == 'USELOCATION') {
            if (e.selectedItem.id === 'N') {
                formRefs.current['R_WAREHOUSE'].instance().option('disabled', true);
                formRefs.current['ALLOWBLANKLOCATIONS'].instance().option('disabled', true);
            }
            else {
                formRefs.current['R_WAREHOUSE'].instance().option('disabled', false);
                formRefs.current['ALLOWBLANKLOCATIONS'].instance().option('disabled', false);
            }
        }
        if (name == 'LOTMETHOD_SHIPMENTS') {
            if (e.selectedItem.id === 'M' || e.selectedItem.id === 'L' || e.selectedItem.id === 'J') {
                formRefs.current['LOTPICKMETHOD_SHIPMENTS'].instance().option('disabled', true);
                formRefs.current['LOTPICKSEQUENCE_SHIPMENTS'].instance().option('disabled', true);
                setformFields(prevFields => ({
                        ...prevFields,
                        LOTPICKMETHOD_SHIPMENTS: null,
                        LOTPICKSEQUENCE_SHIPMENTS: null
                    }));
            }
            else {
                formRefs.current['LOTPICKMETHOD_SHIPMENTS'].instance().option('disabled', false);
                formRefs.current['LOTPICKSEQUENCE_SHIPMENTS'].instance().option('disabled', false);
            }
        }
        if (name == 'SUBLOTMETHOD_SHIPMENTS') {
            if (e.selectedItem.id === 'M') {
                formRefs.current['SUBLOTPICKMETHOD_SHIPMENTS'].instance().option('disabled', true);
                formRefs.current['SUBLOTPICKSEQUENCE_SHIPMENTS'].instance().option('disabled', true);
                setformFields(prevFields => ({
                        ...prevFields,
                        SUBLOTPICKMETHOD_SHIPMENTS: null,
                        SUBLOTPICKSEQUENCE_SHIPMENTS: null
                    }));
            }
            else {
                formRefs.current['SUBLOTPICKMETHOD_SHIPMENTS'].instance().option('disabled', false);
                formRefs.current['SUBLOTPICKSEQUENCE_SHIPMENTS'].instance().option('disabled', false);
            }
        }
        if (name == 'UNITMETHOD_SHIPMENTS') {
            if (e.selectedItem.id === 'M') {
                formRefs.current['UNITPICKMETHOD_SHIPMENTS'].instance().option('disabled', true);
                formRefs.current['UNITPICKSEQUENCE_SHIPMENTS'].instance().option('disabled', true);
                setformFields(prevFields => ({
                        ...prevFields,
                        UNITPICKMETHOD_SHIPMENTS: null,
                        UNITPICKSEQUENCE_SHIPMENTS: null
                    }));
            }
            else {
                formRefs.current['UNITPICKMETHOD_SHIPMENTS'].instance().option('disabled', false);
                formRefs.current['UNITPICKSEQUENCE_SHIPMENTS'].instance().option('disabled', false);
            }
        }
        if (name == 'LOCATIONMETHOD_SHIPMENTS') {
            if (e.selectedItem.id === 'M' || e.selectedItem.id === 'C') {
                formRefs.current['LOCATIONPICKMETHOD_SHIPMENTS'].instance().option('disabled', true);
                formRefs.current['LOCATIONPICKSEQUENCE_SHIPMENTS'].instance().option('disabled', true);
                setformFields(prevFields => ({
                        ...prevFields,
                        LOCATIONPICKMETHOD_SHIPMENTS: null,
                        LOCATIONPICKSEQUENCE_SHIPMENTS: null
                    }));
            }
            else if (e.selectedItem.id === 'D') {
                loadLookupFromStaticData(formRefs, "LOCATIONPICKMETHOD_SHIPMENTS", LOCATIONPICKMETHOD_SHIPMENTS_2);
                formRefs.current['LOCATIONPICKMETHOD_SHIPMENTS'].instance().option('disabled', false);
                formRefs.current['LOCATIONPICKSEQUENCE_SHIPMENTS'].instance().option('disabled', true);
                                setformFields(prevFields => ({
                        ...prevFields,
                        LOCATIONPICKSEQUENCE_SHIPMENTS: null,
                    }));
            }
            else {
                loadLookupFromStaticData(formRefs, "LOCATIONPICKMETHOD_SHIPMENTS", LOCATIONPICKMETHOD_SHIPMENTS);
                formRefs.current['LOCATIONPICKMETHOD_SHIPMENTS'].instance().option('disabled', false);
                formRefs.current['LOCATIONPICKSEQUENCE_SHIPMENTS'].instance().option('disabled', false);
            }
        }
    }, []);
    const handleHeaderFormLoad = useCallback(() => {
        loadLookupClient("STATUS", navReportStatus);
        const showShipperOptions = [
            { Rowid: 'Y', Code: 'Yes - Standard Entry' },
            { Rowid: 'N', Code: 'No' }
        ]
        loadLookupClient("SHOWSHIPPERONRECEIPT", showShipperOptions);
        const RFTransactionOptions = [
            { Rowid: 'Y', Code: 'Yes - Disable the detail, subdetail, location grids, serial number when a Transaction RF' },
            { Rowid: 'N', Code: 'No' }
        ]
        loadLookupClient("RFTRANSACTION", RFTransactionOptions);
        const AllowChangesOptions = [
            { Rowid: 'Y', Code: 'Yes, Allow Changes To Non Critical Header Data For Committed Transaction' },
            { Rowid: 'N', Code: 'No, Do Not Allow Changes To Non Critical Header Data For Committed Transaction' }
        ]
        loadLookupClient("MODIFYCOMMITTEDTRANS", AllowChangesOptions);
        const deleteReceiptsOptions = [
            { Rowid: 'A', Code: 'Yes, Allow Delete of the Receipt Record Regardless Shipment Records Exists' },
            { Rowid: 'C', Code: 'No, Do Not Allow Delete of the Receipt Record When Shipment Records Exists' },
            { Rowid: 'B', Code: 'No, Allow Delete of the Receipt Record With Warning When Shipment Records Exists' }
        ]
        loadLookupClient("DELETERECEIPTS", deleteReceiptsOptions);
        const rateSechduleOptions = [
            { Rowid: 'N', Code: 'No, Do Not Allow User To Manually Select ITEM RATE Schedule When Stage is Completed' },
            { Rowid: 'Y', Code: 'Yes, Allow User To Manually Select ITEM RATE Schedule When Stage is Completed' },
            { Rowid: 'X', Code: 'Do not calculate' }
        ]
        loadLookupClient("ACCESSRATESCHEDULE", rateSechduleOptions);
        const lookupConisgneeOptions = [
            { Rowid: 'N', Code: 'No, Show All Consignees' },
            { Rowid: 'Y', Code: 'Yes, only Show Consignees associated with customer' },
        ]
        loadLookupClient("LIMITCONSIGNEELOOKUP", lookupConisgneeOptions);

        const transGenerationNoOptions = [
            { Rowid: 'A', Code: 'Auto Generate - No Access' },
            { Rowid: 'C', Code: 'Auto Generate - Access' },
            { Rowid: 'U', Code: 'User Entered' },
            { Rowid: 'V', Code: 'User Entered - Validate for duplicate' },
        ]
        loadLookupClient("TRANSNOGENERATION_RECEIPT", transGenerationNoOptions);
        loadLookupClient("TRANSNOGENERATION_SHIPMENT", transGenerationNoOptions);
        loadLookupClient("TRANSNOGENERATION_ADJUSTMENT", transGenerationNoOptions);
        const recvShipDtOptions = [
            { Rowid: 'C', Code: 'Default when at Completed Stage' },
            { Rowid: 'R', Code: 'Default when at Ready to Receive Stage' },
        ]
        loadLookupClient("POPULATEACTUALRSDATE", recvShipDtOptions);

        const fmContentOptions = [
            { Rowid: 'N', Code: 'No, Do Not Create FM Content Record ' },
            { Rowid: 'Y', Code: 'Yes, create FM content with lot code as content' },
            { Rowid: 'I', Code: 'Yes, create FM Contents with item class code as type' },
            { Rowid: 'S', Code: 'Yes, create FM Contents with Sublots ' },
            { Rowid: 'C', Code: 'Yes, Create FM Contents with Crates/Sublots' },
        ]
        loadLookupClient("CREATEFMCONTENTS", fmContentOptions);
        const pickupDateOptions = [
            { Rowid: 'R', Code: 'Recv/Ship Date' },
            { Rowid: 'T', Code: 'Transfer Date' },
        ]
        loadLookupClient("FMPICKUPDATE", pickupDateOptions);
        const fromSateOptions = [
            { Rowid: 'P', Code: 'Plan - No Inventory Effect, No Charges ' },
            { Rowid: 'F', Code: 'Future Order - No Effect On Net Available, No Charges  ' },
            { Rowid: 'N', Code: 'Pending - Effects Net Available, No Charges' },
            { Rowid: 'R', Code: 'Ready To Receive/Pick/Staged - Effects Available, No Charges ' },
            { Rowid: 'C', Code: 'Completed/Loaded/Put Away/Transferred/Adjusted - Effects Available, Yes, Charges' },
        ]
        loadLookupClient("FROMSTAGE_FMTRANSFER", fromSateOptions);
        const fmTrackingNumberOptions = [
            { Rowid: 'A', Code: 'Use WM Transaction as DO Tracking Number' },
            { Rowid: 'B', Code: 'Use Auto Generated DO Tracking Number based on DO Profile' },
        ]
        loadLookupClient("FMTRANSACTIONNUMBER", fmTrackingNumberOptions);
        var toCompanyIDUrl = "ab/Lookup/GetAbCompany";
        var tocompanyiddata = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/${toCompanyIDUrl}`,
                loadParams: {
                    tabelName: 'WMTRANSACTIONDP',
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSourceName("TRANSFERTOCOMPANYID", tocompanyiddata);
        const invoiceSetupOptions = [
            { Rowid: 'N', Code: 'No, Do Not Validate Invoicing Procedure In Customer Master' },
            { Rowid: 'W', Code: 'Yes, Validate Invoicing Procedure In Customer Master With Warning Only ' },
            { Rowid: 'A', Code: 'Yes, Validate Invoicing Procedure In Customer Master and Do Not Allow To Continue' },
        ]
        loadLookupClient("VALIDATEINVOICESETUP", invoiceSetupOptions);
        const allowUserValidationData = [
            { Rowid: 'N', Code: 'No. Do Not Execute User Validation Stored Procedure ' },
            { Rowid: 'Y', Code: 'Yes, Execute User Validation Stored Procedure ' },
            { Rowid: 'C', Code: 'Yes, execute user validation stored procedure and allow cancel' },
            { Rowid: 'D', Code: 'Yes, execute user validation stored procedure upon display ' },
        ]
        loadLookupClient("ALLOWUSERVALIDATION", allowUserValidationData);
        var dataSourcePopupMessage = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.AB.GetPopupMessages}`,
                loadParams: {
                    tabelName: 'WMTRANSACTIONDP',
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSourceName("POPUPMESSAGEUSER", dataSourcePopupMessage);
        const yesNoOptions = [
            { Rowid: 'N', Code: 'No' },
            { Rowid: 'Y', Code: 'Yes' },
        ]
        loadLookupClient("ISPLACEHOLDERRECORD", yesNoOptions);
        loadLookupClient("LOTEXPIRATIONDATECHECK", yesNoOptions);
        loadLookupClient("USERVALIDATIONONCOMMIT", yesNoOptions);
        const allowDuplicateOptions = [
            { Rowid: 'Y', Code: 'Yes. Allow Duplicate PD/Reference #' },
            { Rowid: 'N', Code: 'No. Do Not Allow Duplicate PD/Reference # ' },
            { Rowid: 'W', Code: 'Warn Only. Allow Duplicate PD/Reference # ' },
            { Rowid: 'A', Code: 'No. Do Not Allow Duplicate PD/Reference # But Customer' },
            { Rowid: 'B', Code: 'Warn Only. Allow Duplicate PD/Reference # By Customer' },
        ]
        loadLookupClient("ALLOWDUPLICATEPO", allowDuplicateOptions);
        const carrierTrailerOptions = [
            { Rowid: 'Y', Code: 'Yes. Allow Duplicate Carrier & Trailer # Combination' },
            { Rowid: 'N', Code: 'No. Warn User For Duplicate Carrier & Trailer EIR Combination' },
            { Rowid: 'A', Code: 'No. Warn User For Duplicate Carrier & Trailer Combination - All Status ' },
            { Rowid: 'O', Code: 'No. Warn User For Duplicate Carrier & Trailer Combination - Open Status Only' },
        ]
        loadLookupClient("DUPLICATETRAILERCARRIER", carrierTrailerOptions);
        const shipperDuplicateOptions = [
            { Rowid: 'Y', Code: 'Yes. Allow Duplicate Shipper #' },
            { Rowid: 'W', Code: 'Yes. Allow Duplicate Shipper # With Warning' },
            { Rowid: 'N', Code: 'No. Do Not Allow Duplicate Shipper #' },
        ]
        loadLookupClient("DUPLICATESHIPPERBOLNUMBER", shipperDuplicateOptions);
        loadLookupClient("VALIDATEACTRECSHIPDT", yesNoOptions);
        loadLookupClient("SPLITORDER", yesNoOptions);
        const splitOrderSourceOptions = [
            { Rowid: 'S', Code: 'Shipper/BOL #' },
            { Rowid: 'T', Code: 'Transaction #' },
        ]
        loadLookupClient("SPLITORDERSOURCEFIELD", splitOrderSourceOptions);
        const planDateOptions = [
            { Rowid: 'Y', Code: 'Yes, Default Plan/Appt Date & time from Recive/Ship Date & Time' },
            { Rowid: 'N', Code: 'No, Do Not Default' },
            { Rowid: 'A', Code: 'Yes, Always Update Plan/Appt Date & time from Recive/Ship Date & Time' },
            { Rowid: 'T', Code: 'Yes, Default Plan/Appt Date and Update time from Recive/Ship Date & Time' },
        ]
        loadLookupClient("PLANDATETIMEDEFAULT", planDateOptions);
        const shippingDateOptions = [
            { Rowid: 'N', Code: 'No, Do Not Default' },
            { Rowid: 'A', Code: 'Yes, Always Update Staging Date and Time when Receive/Ship Date Time Changes' },
            { Rowid: 'T', Code: 'Yes, Default Staging Date and Update from Receive/Ship Date and Time' },
            { Rowid: 'Y', Code: 'Yes, Default Staging Date and Time from Receive/Ship Date Time' },
        ]
        loadLookupClient("STAGINGDATETIMEDEFAULT", shippingDateOptions);

        const creditCheckDateOptions = [
            { Rowid: 'N', Code: 'No' },
            { Rowid: 'F', Code: 'Yes - Credit Check From Future Stage' },
            { Rowid: 'P', Code: 'Yes - Credit Check From Pending Stage' },
            { Rowid: 'R', Code: 'Yes - Credit Check From Ready Stage' },
            { Rowid: 'C', Code: 'Yes - Credit Check From Completed Stage' },
        ]
        loadLookupClient("CREDITCHECKONSTAGECHANGE", creditCheckDateOptions);
        
        if (formRefs && formRefs.current && formRefs.current['VALIDATEACTRECSHIPDT']) {
            const ref = formRefs.current['VALIDATEACTRECSHIPDT'];
            if (typeof ref.instance === 'function') {
                const instance = ref.instance();
                if (instance && typeof instance.option === 'function') {
                    let v = instance.option('value');
                    if (v == 'N') {
                        if (formRefs.current['ACTRECSHIPDTDAYSBEHIND']) {
                            const ref2 = formRefs.current['ACTRECSHIPDTDAYSBEHIND'];
                            if (typeof ref2.instance === 'function') {
                                const instance2 = ref2.instance();
                                if (instance2 && typeof instance2.option === 'function') {
                                    instance2.option('disabled', true);
                                }
                            }
                        }
                        if (formRefs.current['ACTRECSHIPDTDAYSAHEAD']) {
                            const ref3 = formRefs.current['ACTRECSHIPDTDAYSAHEAD'];
                            if (typeof ref3.instance === 'function') {
                                const instance3 = ref3.instance();
                                if (instance3 && typeof instance3.option === 'function') {
                                    instance3.option('disabled', true);
                                }
                            }
                        }
                    } else {
                        if (formRefs.current['ACTRECSHIPDTDAYSBEHIND']) {
                            const ref2 = formRefs.current['ACTRECSHIPDTDAYSBEHIND'];
                            if (typeof ref2.instance === 'function') {
                                const instance2 = ref2.instance();
                                if (instance2 && typeof instance2.option === 'function') {
                                    instance2.option('disabled', false);
                                }
                            }
                        }
                        if (formRefs.current['ACTRECSHIPDTDAYSAHEAD']) {
                            const ref3 = formRefs.current['ACTRECSHIPDTDAYSAHEAD'];
                            if (typeof ref3.instance === 'function') {
                                const instance3 = ref3.instance();
                                if (instance3 && typeof instance3.option === 'function') {
                                    instance3.option('disabled', false);
                                }
                            }
                        }
                    }
                }
            }
        }
    }, []);
    const handlePrimaryFormLoad = useCallback(() => {

        var dataSourcePopupMessage = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.AB.GetPopupMessages}`,
                loadParams: {
                    tabelName: 'WMTRANSACTIONDP',
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSourceName("POPUPMESSAGE", dataSourcePopupMessage);
        var dataSourceCode1 = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                loadParams: {
                    codeType: function () {
                        return "57";
                    }
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSourceName("USERDEFINEDCODE_1", dataSourceCode1);
        var dataSourceCode2 = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                loadParams: {
                    codeType: function () {
                        return "58";
                    }
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSourceName("USERDEFINEDCODE_2", dataSourceCode2);
        var dataSourceCode3 = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                loadParams: {
                    codeType: function () {
                        return "59";
                    }
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSourceName("USERDEFINEDCODE_3", dataSourceCode3);
        var dataSourceCode4 = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                loadParams: {
                    codeType: function () {
                        return "60";
                    }
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSourceName("USERDEFINEDCODE_4", dataSourceCode4);
        var dataSourceCode5 = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                loadParams: {
                    codeType: function () {
                        return "61";
                    }
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSourceName("USERDEFINEDCODE_5", dataSourceCode5);

    }, []);
    const handleDetailsFormLoad = useCallback(() => {
        const useLocation = [{ id: 'Y', name: 'Yes, Track By Location In Entry' },
        { id: 'V', name: 'Yes, Track By Location In Entry & Give Warning If Location is Not Empty (Receipts Only)' }, { id: 'N', name: 'No, Do Not Track By Location In Entry' }]
        const blankLocation = [{ id: 'Y', name: 'Yes, Allow Blank Locations - No, Do Not Validate For Blank Locations' }, { id: 'N', name: 'No, Do Not Allow Blank Locations - Validate When Exit From The Transaction (Completed Stage Only)' }, { id: 'C', name: 'No, Do Not Allow Blank Locations - Validate During Transaction Commit Process' }, { id: 'B', name: 'No, Do Not Allow Blank Locations - Validate Both, When Exit From The Transaction & During Transaction Commit Process' }]
        const filterLocation = [{ id: 'Y', name: 'Filter Location COde lookup by Item Class/Subclass' }, { id: 'N', name: 'No' }, { id: 'W', name: 'Filter Location COde lookup by Item Class/Subclass - Warning Only' }]

        const lot = [{ id: 'M', name: 'Manually Entered' }, { id: 'S', name: 'Sequentially Auto Generate Based On Configuration Record' }, { id: 'J', name: 'Select from calendar and convert to julian date' }]
        const sublot = [{ id: 'M', name: 'Manually Entered' }, { id: 'S', name: 'Sequentially Auto Generate Based On Configuration Record' }, { id: 'U', name: 'Auto Generate Based On User Configuration' }]
        const unit = [{ id: 'M', name: 'Manually Entered' }, { id: 'S', name: 'Sequentially Auto Generate Based On Configuration Record' }]
        const location = [{ id: 'W', name: 'Default From Default Warehouse' }, { id: 'F', name: 'Default From Item Forward Pick' }, { id: 'R', name: 'Default From Item Replenishmenr' }, { id: 'V', name: 'Default From Item Rserve' }, { id: 'S', name: 'Default From Staging Area' }]

        const lotMaster = [{ id: 'N', name: 'No, Do Not Access Lot Entry Screen' }, { id: 'S', name: 'No, Do Not Access Lot Entry Screen & Skip Warning' }, { id: 'Y', name: 'Yes, Access Lot Entry Screen' }, { id: 'F', name: 'Yes, Always use Lot Regular Entry Screen' }, { id: 'M', name: 'Yes, Always use Lot Quick Entry Screen' }]
        const sublotMaster = [{ id: 'N', name: 'No, Do Not Access Sublot Entry Screen' }, { id: 'Y', name: 'Yes, Access Sublot Entry Screen' }, { id: 'A', name: 'Yes, Access Sublot Quick Entry Reguler Screen' }, { id: 'B', name: 'Yes, Access Sublot Quick Entry With Weight Calculation Screen' }]
        const unitMaster = [{ id: 'N', name: 'No, Do Not Access Unit Entry Screen' }, { id: 'Y', name: 'Yes, Access Unit Entry Screen' }]

        const SHIPMENTSONNEG_AVL = [
            { id: 'N', name: 'No, Item Available Quantity Must Be = OR > Shipment Quantity' },
            { id: 'A', name: 'No, Item Net Available Quantity Must Be = OR > Shipment Quantity' },
            { id: 'Y', name: 'Yes, Allow Shipment Regardless Of Item Available Quantity' },
            { id: 'B', name: 'Yes, Allow Shipment Regardless Of Item Net Available Quantity' }
        ]

        const IGNORESAMEDAYSHIPTIME = [
            { id: 'N', name: 'No, do not ignore the time on shipments' },
            { id: 'Y', name: 'Yes, ignore the time on shipments' },
        ]
        const SHIPMENTSONNET_AVL = [
            { id: 'Y', name: 'Yes, allow ordered qty > net avail at Pending Stage' },
            { id: 'N', name: 'No, do not allow ordered qty > net avail at pending stage' },
            { id: 'A', name: 'No, do not allow quantity > net available less pending receipts' },
            { id: 'B', name: 'No, do not allow ordered qty > net avail at Pending/Ready/Completed Stage' }
        ]
        const SHIPMENTQTYCHKONDTLSAVE = [
            { id: 'N', name: 'No (Default)' },
            { id: 'Y', name: 'Yes' },
        ]

        const LOTMETHOD_SHIPMENTS = [
            { id: 'M', name: 'Manually Enter Lot During Entry Process ' },
            { id: 'A', name: 'Auto Select Based On Lot Master' },
            { id: 'D', name: 'Auto Default Based On Lot Master' },
            { id: 'L', name: 'Show List With All Available Lots, Sublots & Locations To Manually Select ' },
            { id: 'J', name: 'Select from calendar and convert to julian date' }
        ]
        const SUBLOTMETHOD_SHIPMENTS = [
            { id: 'M', name: 'Manually Enter Sublot During Entry Process ' },
            { id: 'A', name: 'Auto Select Based On Sublot Master' },
            { id: 'D', name: 'Auto Default Based On Sublot Master' }
        ]
        const UNITMETHOD_SHIPMENTS = [
            { id: 'M', name: 'Manually Enter Unit During Entry Process ' },
            { id: 'D', name: 'Auto Default Based On Unit Master' }
        ]
        const LOCATIONMETHOD_SHIPMENTS = [
            { id: 'M', name: 'Manually Enter Location During Entry Process ' },
            { id: 'A', name: 'Auto Select Based On Location Master' },
            { id: 'D', name: 'Auto Default Based On Item Master' },
            { id: 'C', name: 'Custom Location Allocation' }
        ]
        const LOTPICKMETHOD_SHIPMENTS = [
            { id: 'L', name: 'Lot Code' },
            { id: 'D', name: 'Description - 1' },
            { id: 'C', name: 'Class Code' },
            { id: 'S', name: 'Sub Class Code' },
            { id: 'I', name: 'Date Introduced' },
            { id: 'A', name: 'Date Available' },
            { id: 'E', name: 'Date Expiration' }
        ]

        const SUBLOTPICKMETHOD_SHIPMENTS = [
            { id: 'S', name: 'Sublot Code' },
            { id: 'D', name: 'Description - 1' },
            { id: 'I', name: 'Date Introduced' },
            { id: 'A', name: 'Date Available' },
            { id: 'E', name: 'Date Expiration' }
        ]
        const UNITPICKMETHOD_SHIPMENTS = [
            { id: 'U', name: 'Unit Code' },
            { id: 'I', name: 'Date Introduced' },
            { id: 'A', name: 'Date Available' },
            { id: 'E', name: 'Date Expiration' }
        ]

        const LOTPICKSEQUENCE_SHIPMENTS = [
            { id: 'A', name: 'Ascending' },
            { id: 'D', name: 'Descending' }
        ]
        const DEFAULTITEMLOTMANAGEMENTUNIT = [
            { id: 'I', name: 'Default From Item Master Record' },
            { id: 'T', name: 'Default From Transaction Header Record' },
            { id: 'M', name: 'Manual Entry' }
        ]
        const POPULATELOTWITHCARRIER = [
            { id: 'S', name: 'Populate Carrier ID & Carrier SCAC into LOT User Defined Reference 1 & 2' },
            { id: 'I', name: 'Populate Carrier ID into LOT User Defined Reference 1' },
            { id: 'N', name: 'Do not populate Carrier information into LOT' }
        ]
        const LOTSTORAGEDATE = [
            { id: 'Y', name: 'Yes, default Item/Lot/Sublot storage start date to Receipt Date' },
            { id: 'N', name: 'No. do not default Item/Lot/Sublot storage start date' }
        ]
        const LOTAVAILABLEDATE = [
            { id: 'N', name: 'No, do not update - only during initial creation' },
            { id: 'I', name: 'Update item/lot/sublot available and storage billing start date fields' },
            { id: 'L', name: 'Update lot/sublot available and storage billing start date fields' },
            { id: 'S', name: 'Update sublot available and storage billing start date fields' }
        ]
        const DUPLICATELOT = [
            { id: 'Y', name: 'Do Not Validate For Duplicate Lot Codes' },
            { id: 'W', name: 'Validate For Same Lot Code For Multiple Receipts Regardless Of Customer - Allow User To Continue With Warning ' },
            { id: 'N', name: 'Validate For Same Lot Code For Multiple Receipts Regardless Of Customer - Do Not Allow User To Continue ' },
            { id: 'C', name: 'Validate For Same Lot Code For Multiple Receipts By Customer - Allow Use To Continue With Warning ' },
            { id: 'D', name: 'Validate For Same Lot Code For Multiple Receipts By Customer - Do Not Allow User To Continue ' }
        ]
        const DUPLICATESUBLOT = [
            { id: 'Y', name: 'Yes, Allow Same Sublot Code For Multiple Receipts' },
            { id: 'W', name: 'Yes, Allow Same Sublot Code For Multiple Receipts W/Warning' },
            { id: 'N', name: 'No, Do Not Allow Same Sublot Code In Multiple Receipts' }
        ]
        const DETAILUDFIELDS = [
            { id: 'N', name: 'No defaults' },
            { id: 'L', name: 'Default from Lot #39 s UD fields' }
        ]
        const UPDATEUDFIELDS = [
            { id: 'N', name: 'Do Not Update' },
            { id: 'L', name: 'Update Lot #39s UD Fields' }
        ]
        const YesNo = [
            { id: 'Y', name: 'Yes' },
            { id: 'N', name: 'No' }
        ]


        loadLookupFromStaticData(formRefs, "USELOCATION", useLocation);
        loadLookupFromStaticData(formRefs, "ALLOWBLANKLOCATIONS", blankLocation);
        loadLookupFromStaticData(formRefs, "LOCATIONBYCLASS", filterLocation);
        loadLookupFromStaticData(formRefs, "RECEIVINGMETHOD_LOT", lot);
        loadLookupFromStaticData(formRefs, "RECEIVINGMETHOD_SUBLOT", sublot);
        loadLookupFromStaticData(formRefs, "RECEIVINGMETHOD_UNIT", unit);
        loadLookupFromStaticData(formRefs, "LOCATIONMETHOD_RECEIPTS", location);
        loadLookupFromStaticData(formRefs, "SHOWMASTER_LOT", lotMaster);
        loadLookupFromStaticData(formRefs, "SHOWMASTER_SUBLOT", sublotMaster);
        loadLookupFromStaticData(formRefs, "SHOWMASTER_UNIT", unitMaster);
        loadLookupFromStaticData(formRefs, "SHIPMENTSONNEG_AVL", SHIPMENTSONNEG_AVL);
        loadLookupFromStaticData(formRefs, "IGNORESAMEDAYSHIPTIME", IGNORESAMEDAYSHIPTIME);
        loadLookupFromStaticData(formRefs, "SHIPMENTSONNET_AVL", SHIPMENTSONNET_AVL);
        loadLookupFromStaticData(formRefs, "SHIPMENTQTYCHKONDTLSAVE", SHIPMENTQTYCHKONDTLSAVE);
        loadLookupFromStaticData(formRefs, "LOTMETHOD_SHIPMENTS", LOTMETHOD_SHIPMENTS);
        loadLookupFromStaticData(formRefs, "SUBLOTMETHOD_SHIPMENTS", SUBLOTMETHOD_SHIPMENTS);
        loadLookupFromStaticData(formRefs, "UNITMETHOD_SHIPMENTS", UNITMETHOD_SHIPMENTS);
        loadLookupFromStaticData(formRefs, "LOCATIONMETHOD_SHIPMENTS", LOCATIONMETHOD_SHIPMENTS);
        loadLookupFromStaticData(formRefs, "LOTPICKMETHOD_SHIPMENTS", LOTPICKMETHOD_SHIPMENTS);
        loadLookupFromStaticData(formRefs, "SUBLOTPICKMETHOD_SHIPMENTS", SUBLOTPICKMETHOD_SHIPMENTS);
        loadLookupFromStaticData(formRefs, "UNITPICKMETHOD_SHIPMENTS", UNITPICKMETHOD_SHIPMENTS);
        loadLookupFromStaticData(formRefs, "LOCATIONPICKMETHOD_SHIPMENTS", LOCATIONPICKMETHOD_SHIPMENTS);
        loadLookupFromStaticData(formRefs, "LOTPICKSEQUENCE_SHIPMENTS", LOTPICKSEQUENCE_SHIPMENTS);
        loadLookupFromStaticData(formRefs, "SUBLOTPICKSEQUENCE_SHIPMENTS", LOTPICKSEQUENCE_SHIPMENTS);
        loadLookupFromStaticData(formRefs, "UNITPICKSEQUENCE_SHIPMENTS", LOTPICKSEQUENCE_SHIPMENTS);
        loadLookupFromStaticData(formRefs, "LOCATIONPICKSEQUENCE_SHIPMENTS", LOTPICKSEQUENCE_SHIPMENTS);
        loadLookupFromStaticData(formRefs, "DEFAULTITEMLOTMANAGEMENTUNIT", DEFAULTITEMLOTMANAGEMENTUNIT);
        loadLookupFromStaticData(formRefs, "POPULATELOTWITHCARRIER", POPULATELOTWITHCARRIER);
        loadLookupFromStaticData(formRefs, "LOTSTORAGEDATE", LOTSTORAGEDATE);
        loadLookupFromStaticData(formRefs, "LOTAVAILABLEDATE", LOTAVAILABLEDATE);
        loadLookupFromStaticData(formRefs, "DUPLICATELOT", DUPLICATELOT);
        loadLookupFromStaticData(formRefs, "DUPLICATESUBLOT", DUPLICATESUBLOT);
        loadLookupFromStaticData(formRefs, "UPDATEUDFIELDS", UPDATEUDFIELDS);
        loadLookupFromStaticData(formRefs, "DETAILUDFIELDS", DETAILUDFIELDS);
        loadLookupFromStaticData(formRefs, "REASONMANDATORY", YesNo);
        loadLookupFromStaticData(formRefs, "USEONESSCCPERTRANS", YesNo);

        loadLookupFromByDataSource(formRefs, "R_WAREHOUSE", `${window._env_.REACT_APP_APIS}/${data.ID.GetWarehouses}`, 'id', 'name');
    }, []);

    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };
    const loadLookupFromByDataSource = (formRefs, name, url, valueExpr, displayExpr, loadParams = null) => {
        var dataSource = new DataSource({
            store: new createStore({
                key: valueExpr,
                loadUrl: url,
                loadParams: loadParams,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: displayExpr, desc: false }],
            paginate: true,
            pageSize: 100
        });
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }
    };
    const handlRepackFormLoad = useCallback(() => {
        var updateModes = [{ "Rowid": "N", "Code": "No, Do Not Update Associated Repack Record When Stage is Changed in the Active Record" }
            , { "Rowid": "Y", "Code": "Yes, Automatically Update Associated Repack Record When Stage is Changed in the Active Record" },
        { "Rowid": "A", "Code": "Yes, Give Warning and Update Associated Repack Record When Stage is Changed in the Active Record" }];
        loadLookupClient("REPACKUPDATEMODE", updateModes);

        var deleteModes = [{ "Rowid": "N", "Code": "No, Do Not Delete Associated Repack Record When Active Record is Deleted" }
            , { "Rowid": "Y", "Code": "Yes, Automatically Delete Associated Repack Record When Active Record is Deleted" },
        { "Rowid": "A", "Code": "Yes, Give Warning and Allow Delete Associated Repack Record When Active Record is Deleted" }];
        loadLookupClient("REPACKDELETEMODE", deleteModes);
        var dataSourceShippedProfiles = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/TransactionDataProfile/GetProfiles`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSource("R_REPACKSHIPMENT_PROFILE", dataSourceShippedProfiles);
    }, []);



    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        skipDataLoading = false;
        history.push('/im/AddLocationCodes');
        EnableControlsForNewRecord();
    }
    const deleteRecords = useCallback(() => {
        var deleteUrl = "wm/TransactionDataProfile/DeleteTransactionProfile";
        let result = confirm("<i>Are your sure you want to delete record?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                        formFields.ROWID,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        notify(
                            {
                                message: "Transaction Deleted",
                                width: 600,
                            },
                            'success',
                            3000,
                        );
                        goBack();
                    })
                    .catch((err) => {
                    });

            }
        });

    }, [formFields.ROWID]);

    const setSelectBoxValueByDisplay = async (formRefs, refKey, displayValue, newItems = []) => {
        const instance = formRefs?.current[refKey]?.instance();
        if (!instance || displayValue === null) return;

        const store = instance.option('dataSource');
        const displayExpr = instance.option('displayExpr');
        const valueExpr = instance.option('valueExpr');

        try {
            const existingData = await store?.load();
            const updatedData = [...newItems, ...existingData || []];
            const newStore = new ArrayStore({
                key: 'id',
                data: updatedData,
            });

            // Set new store to the select box
            instance.option('dataSource', newStore);
            const matchedItem = updatedData.find(item => item[displayExpr] === displayValue);
            if (matchedItem) {
                instance.option('value', matchedItem[valueExpr]);
            } else {
                console.warn(`No match found for ${displayValue} in ${refKey}`);
            }
        } catch (error) {
            console.error(`Error loading store for ${refKey}`, error);
        }
    };
    const loadLookupDataNetReport = (formRefs, name, url, valueExpr, displayExpr, parametername = null) => {
        const dataSource = new DataSource({
            store: new createStore({
                key: valueExpr,
                loadUrl: url,
                loadParams: {
                    name: parametername,
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }

            }),
            sort: [{ selector: displayExpr, desc: false }],
            paginate: true,
            pageSize: 100
        });
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
            if (formFields[name]) {
                formRefs.current[name].instance().option('value', formFields[name]);
            }
        }
    };
    const loadLookupData = (formRefs, name, url, valueExpr, displayExpr, module = null) => {
        const dataSource = new DataSource({
            store: new createStore({
                key: valueExpr,
                loadUrl: url,
                loadParams: {
                    module: module,
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }

            }),
            sort: [{ selector: 'description', desc: false }],
            paginate: true,
            pageSize: 100
        });

        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
            if (formFields[name]) {
                formRefs.current[name].instance().option('value', formFields[name]);
            }
        }
    };
    const loadLookupClientData = (name, data) => {

        try {
            const newOptions = data.map(item => ({
                id: item.uuid,
                name: item.name
            }));
            if (formRefs.current[name]) {

                formRefs.current[name].instance().option('dataSource', newOptions);
                formRefs.current[name].instance().option('valueExpr', 'id');
                formRefs.current[name].instance().option('displayExpr', 'name');
            }

        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
        }
    };
    const printEditReports = [
        {
            uuid: '0||Standard Abecas - Item/Lot||rptTransaction_ItemLot',
            name: 'Standard Abecas - Item/Lot',
            description: 'rptTransaction_ItemLot'
        },
        {
            uuid: '0||Standard Abecas - Full Report||rptRecShipEdit',
            name: 'Standard Abecas - Full Report',
            description: 'rptRecShipEdit'
        },
        {
            uuid: '0||Control Log||rptRecShipEditControlLog',
            name: 'Control Log',
            description: 'rptRecShipEditControlLog'
        },
    ];
    const standard = [
        {
            uuid: '0||Standard Abecas||rptWMBillofLading',
            name: 'Standard Abecas',
            description: 'rptWMBillofLading'
        }
    ];
    const bolFormats = [
        {
            uuid: '0||Standard Abecas||rptWMBillofLading',
            name: 'Standard Abecas',
            description: 'rptWMBillofLading'
        },
        {
            uuid: '0||Standard Abecas With Serial Numbers||rptShipmentManifest',
            name: 'Standard Abecas With Serial Numbers',
            description: 'rptShipmentManifest'
        },
        {
            uuid: '0||Standard Abecas - Hazardous Materials||rptHazMat',
            name: 'Standard Abecas - Hazardous Materials',
            description: 'rptHazMat'
        },
        {
            uuid: '0||Standard Abecas - Hazmat DOT||rptHazMatDOT',
            name: 'Standard Abecas - Hazmat DOT',
            description: 'rptHazMatDOT'
        },
        {
            uuid: '0||11 X 8 1/2 X Dot Matrix||rptMichaelSkurnikWines',
            name: '11 X 8 1/2 X Dot Matrix',
            description: 'rptMichaelSkurnikWines'
        },
        {
            uuid: '0||11 X 8 1/2 X Dot Matrix2||rptDotMatrix2',
            name: '11 X 8 1/2 X Dot Matrix2',
            description: 'rptDotMatrix2'
        },
        {
            uuid: '0||FDL Base Format||rptFDL',
            name: 'FDL Base Format',
            description: 'rptFDL'
        }
    ];
    const simpleFormats = [
        {
            uuid: '0||Standard Abecas||rptBillOfLading',
            name: 'Standard Abecas',
            description: 'rptBillOfLading'
        }
    ];
    const specialFormats = [
        {
            uuid: '0||Standard Abecas||rptWMBillofLading',
            name: 'Standard Abecas',
            description: 'rptWMBillofLading'
        }
    ];
    const pickingSlipFormats = [
        {
            uuid: '0||Standard Abecas - All Locations||rptWMPickingSlip_AllLocations',
            name: 'Standard Abecas - All Locations',
            description: 'rptWMPickingSlip_AllLocations'
        },
        {
            uuid: '0||Standard Abecas - Assigned Locations||rptWMPickingSlip_Assigned',
            name: 'Standard Abecas - Assigned Locations',
            description: 'rptWMPickingSlip_Assigned'
        },
        {
            uuid: '0||Standard Abecas - Crate||rptWMPickingSlip_AssignedCrate',
            name: 'Standard Abecas - Crate',
            description: 'rptWMPickingSlip_AssignedCrate'
        },
        {
            uuid: '0||Standard Abecas - Order By Class Code||rptPickingSlipByClassCode',
            name: 'Standard Abecas - Order By Class Code',
            description: 'rptPickingSlipByClassCode'
        },
        {
            uuid: '0||Standard Abecas - Order By Locations||rptPickingSlipByLocation',
            name: 'Standard Abecas - Order By Locations',
            description: 'rptPickingSlipByLocation'
        },
        {
            uuid: '0||Standard Abecas Sublot - All Locations||rptWMPickingSlip_AllLocSblt',
            name: 'Standard Abecas Sublot - All Locations',
            description: 'rptWMPickingSlip_AllLocSblt'
        },
        {
            uuid: '0||Standard Abecas Sublot - Assgn Locations||rptWMPickingSlip_AssignedSublot',
            name: 'Standard Abecas Sublot - Assgn Locations',
            description: 'rptWMPickingSlip_AssignedSublot'
        }
    ];
    const shippingLabelFormats = [
        {
            uuid: '0||Standard Abecas - Crates||rptShippingLabelsCrates',
            name: 'Standard Abecas - Crates',
            description: 'rptShippingLabelsCrates'
        },
        {
            uuid: '0||Standard Abecas||rptShippingLabels',
            name: 'Standard Abecas',
            description: 'rptShippingLabels'
        }
    ];
    const shippingFormats = [
        {
            uuid: '0||Standard Abecas||rptShippingLabels',
            name: 'Standard Abecas',
            description: 'rptShippingLabels'
        }
    ];
    const ssccLabelFormats = [
        {
            uuid: '0||Standard Abecas||rptSSCCLabels',
            name: 'Standard Abecas',
            description: 'rptSSCCLabels'
        }
    ];
    const serialNumberManifestFormats = [
        {
            uuid: '0||Standard Abecas||rptSerialNumberManifest',
            name: 'Standard Abecas',
            description: 'rptSerialNumberManifest'
        }
    ];

    const pickSlipSequenceFormats = [
        {
            uuid: '0||Standard Abecas||rptWMPickSlipByPickSequence',
            name: 'Standard Abecas',
            description: 'rptWMPickSlipByPickSequence'
        }
    ];

    const putAwayFormats = [
        {
            uuid: '0||Standard Abecas - Crate||rptReceiptPutAway_Crate',
            name: 'Standard Abecas - Crate',
            description: 'rptReceiptPutAway_Crate'
        },
        {
            uuid: '0||Standard Abecas - Sublot||rptReceiptPutAway_SubLot',
            name: 'Standard Abecas - Sublot',
            description: 'rptReceiptPutAway_SubLot'
        },
        {
            uuid: '0||Standard Abecas||rptReceiptPutAway',
            name: 'Standard Abecas',
            description: 'rptReceiptPutAway'
        }
    ];
    const receiptConfirmationFormats = [
        {
            uuid: '0||Standard Abecas||rptReceiptConfirmationWOLocation',
            name: 'Standard Abecas',
            description: 'rptReceiptConfirmationWOLocation'
        }
    ];
    const receivingLabelFormats = [
        {
            uuid: '0||Standard Abecas||rptReceivingLabels',
            name: 'Standard Abecas',
            description: 'rptReceivingLabels'
        }
    ];
    const navReportStatus = [
        { Rowid: "A", Code: "Active" },
        { Rowid: "I", Code: "Inactive" },
    ];
    const navReportType = [
        { Rowid: "R", Code: "ABECAS Insight Report" },
        { Rowid: "T", Code: ".Net Report" },
        { Rowid: "A", Code: "Advanced Reporting Tool Report" },
    ];
    const handlPrintFormatFormLoad = useCallback(() => {
        let typeValue = null;
        if (formRefs && formRefs.current && formRefs.current['NAVREPORT1TYPE']) {
            const ref = formRefs.current['NAVREPORT1TYPE'];
            if (typeof ref.instance === 'function') {
                const instance = ref.instance();
                if (instance && typeof instance.option === 'function') {
                    typeValue = instance.option('value');
                }
            }
        }
        if (typeValue == 'T') {
            loadLookupDataNetReport(
                formRefs,
                "NAVREPORT1FORMAT",
                `${window._env_.REACT_APP_APIS}/ab/Lookup/GetARTReports`,
                'name',
                'name',
                navrpt1name
            );
            setSelectBoxValueByDisplay(formRefs, 'NAVREPORT1FORMAT', "name", standard);
        } else {
            loadLookupData(
                formRefs,
                "NAVREPORT1FORMAT",
                `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
                'name',
                'name',
                navrpt1name
            );
        }


        const instance2 = formRefs.current['NAVREPORT2TYPE']?.instance();
        const typeValue2 = instance2?.option('value');
        if (typeValue2 == 'T') {
            loadLookupDataNetReport(
                formRefs,
                "NAVREPORT2FORMAT",
                `${window._env_.REACT_APP_APIS}/ab/Lookup/GetARTReports`,
                'name',
                'name',
                navrpt2name
            );
            setSelectBoxValueByDisplay(formRefs, 'NAVREPORT2FORMAT', "name", standard);
        } else {
            loadLookupData(
                formRefs,
                "NAVREPORT2FORMAT",
                `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
                'name',
                'name',
                navrpt2name
            );
        }

        const instance3 = formRefs.current['NAVREPORT3TYPE']?.instance();
        const typeValue3 = instance3?.option('value');
        if (typeValue3 === 'T') {
            loadLookupDataNetReport(
                formRefs,
                "NAVREPORT3FORMAT",
                `${window._env_.REACT_APP_APIS}/ab/Lookup/GetARTReports`,
                'name',
                'name',
                navrpt3name
            );
            setSelectBoxValueByDisplay(formRefs, 'NAVREPORT3FORMAT', "name", standard);
        } else {
            loadLookupData(
                formRefs,
                "NAVREPORT3FORMAT",
                `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
                'name',
                'name',
                navrpt3name
            );
        }

        const instance4 = formRefs.current['NAVREPORT4TYPE']?.instance();
        const typeValue4 = instance4?.option('value');

        if (typeValue4 === 'T') {
            loadLookupDataNetReport(
                formRefs,
                "NAVREPORT4FORMAT",
                `${window._env_.REACT_APP_APIS}/ab/Lookup/GetARTReports`,
                'name',
                'name',
                navrpt4name
            );
            setSelectBoxValueByDisplay(formRefs, 'NAVREPORT4FORMAT', "name", standard);
        } else {
            loadLookupData(
                formRefs,
                "NAVREPORT4FORMAT",
                `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
                'name',
                'name',
                navrpt4name
            );
        }


        loadLookupData(
            formRefs,
            "PRINTEDITREPORT",
            `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
            'uuid',
            'name',
            'frmWMR0001'
        );
        //setSelectBoxValueByDisplay(formRefs, 'PRINTEDITREPORT', "name", printEditReports);
        loadLookupData(
            formRefs,
            "PRINTBOLFORMAT",
            `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
            'uuid',
            'name',
            'frmWMR0034'
        );
        //setSelectBoxValueByDisplay(formRefs, 'PRINTBOLFORMAT', "name", bolFormats);
        loadLookupData(
            formRefs,
            "PRINTBOLFORMAT_SIMPLE",
            `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
            'uuid',
            'name',
            'frmWMR0064'
        );
        //setSelectBoxValueByDisplay(formRefs, 'PRINTBOLFORMAT_SIMPLE', "name", simpleFormats);
        loadLookupClientData("PRINTBOLFORMAT_SPECIAL", specialFormats);
        loadLookupData(
            formRefs,
            "PRINTPICKINGSLIPFORMAT",
            `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
            'uuid',
            'name',
            'frmWMR0005'
        );
        //setSelectBoxValueByDisplay(formRefs, 'PRINTPICKINGSLIPFORMAT', "name", pickingSlipFormats);
        loadLookupData(
            formRefs,
            "PRINTSHIPPINGLABEL",
            `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
            'uuid',
            'name',
            'frmWMR0063'
        );
        //setSelectBoxValueByDisplay(formRefs, 'PRINTSHIPPINGLABEL', "name", shippingLabelFormats);
        loadLookupClientData("PRINTSERIALNUMBERLABEL", shippingFormats);
        loadLookupData(
            formRefs,
            "PRINTSSCCLABEL",
            `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
            'uuid',
            'name',
            'frmWMR0096'
        );
        //setSelectBoxValueByDisplay(formRefs, 'PRINTSSCCLABEL', "name", ssccLabelFormats);
        loadLookupClientData("PRINTSERIALNOMANIFESTREV", serialNumberManifestFormats);
        loadLookupData(
            formRefs,
            "PRINTPICKINGSLIPSEQUENCE",
            `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
            'uuid',
            'name',
            'frmWMR0084'
        );
        //setSelectBoxValueByDisplay(formRefs, 'PRINTPICKINGSLIPSEQUENCE', "name", pickSlipSequenceFormats);
        loadLookupData(
            formRefs,
            "PRINTPUTAWAY",
            `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
            'uuid',
            'name',
            'frmWMR0025'
        );
        //setSelectBoxValueByDisplay(formRefs, 'PRINTPUTAWAY', "name", putAwayFormats);
        loadLookupData(
            formRefs,
            "PRINTRECEIVINGLABEL",
            `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
            'uuid',
            'name',
            'frmWMR0088'
        );
        //setSelectBoxValueByDisplay(formRefs, 'PRINTRECEIVINGLABEL', "name", receivingLabelFormats);
        loadLookupData(
            formRefs,
            "PRINTRECEIPTCONFIRMATION",
            `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
            'uuid',
            'name',
            'frmWMR0007'
        );
        //setSelectBoxValueByDisplay(formRefs, 'PRINTRECEIPTCONFIRMATION', "name", receiptConfirmationFormats);
        loadLookupClient("NAVREPORT1STATUS", navReportStatus);
        loadLookupClient("NAVREPORT1TYPE", navReportType);

        loadLookupClient("NAVREPORT2STATUS", navReportStatus);
        loadLookupClient("NAVREPORT2TYPE", navReportType);

        loadLookupClient("NAVREPORT3STATUS", navReportStatus);
        loadLookupClient("NAVREPORT3TYPE", navReportType);

        loadLookupClient("NAVREPORT4STATUS", navReportStatus);
        loadLookupClient("NAVREPORT4TYPE", navReportType);




        if (formRefs.current['NAVREPORT1STATUS']) {
            const instance = formRefs.current['NAVREPORT1STATUS'].instance();
            let v = instance.option('value');
            if (v == 'I') {
                formRefs.current['NAVREPORT1TEXT'].instance().option('disabled', true);
                formRefs.current['NAVREPORT1TYPE'].instance().option('disabled', true);
                formRefs.current['NAVREPORT1NAME'].instance().option('disabled', true);
                formRefs.current['NAVREPORT1FORMAT'].instance().option('disabled', true);
            }
        }
        if (formRefs.current['NAVREPORT1TYPE']) {
            const instance = formRefs.current['NAVREPORT1TYPE'].instance();
            let v = instance.option('value');
            if (v == 'R') {
                var url = 'wm/TransactionDataProfile/GetReportNamesAbecasInsightReport';
                var dataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSource("NAVREPORT1NAME", dataSource);
                if (formRefs.current['NAVREPORT1FORMAT']) {
                    formRefs.current['NAVREPORT1FORMAT'].instance().option('disabled', false);
                }
            }
            if (v == 'T') {
                var url = 'wm/TransactionDataProfile/GetReportNamesDotNetReport';
                var dataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSource("NAVREPORT1NAME", dataSource);
                if (formRefs.current['NAVREPORT1FORMAT']) {
                    formRefs.current['NAVREPORT1FORMAT'].instance().option('disabled', false);
                }
            }
            if (v == 'A') {
                if (formRefs.current['NAVREPORT1FORMAT']) {
                    formRefs.current['NAVREPORT1FORMAT'].instance().option('disabled', true);
                }
                var url = 'wm/TransactionDataProfile/GetReportNamesAdvanceReportTool';
                var dataSource = new DataSource({
                    store: new createStore({
                        key: 'name',
                        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSourceName("NAVREPORT1NAME", dataSource);
            }
        }

        // NAVREPORT2
        if (formRefs.current['NAVREPORT2STATUS']) {
            const instance = formRefs.current['NAVREPORT2STATUS'].instance();
            let v = instance.option('value');
            if (v == 'I') {
                formRefs.current['NAVREPORT2TEXT'].instance().option('disabled', true);
                formRefs.current['NAVREPORT2TYPE'].instance().option('disabled', true);
                formRefs.current['NAVREPORT2NAME'].instance().option('disabled', true);
                formRefs.current['NAVREPORT2FORMAT'].instance().option('disabled', true);
            }
        }

        if (formRefs.current['NAVREPORT2TYPE']) {
            const instance = formRefs.current['NAVREPORT2TYPE'].instance();
            let v = instance.option('value');
            if (v == 'R') {
                var url = 'wm/TransactionDataProfile/GetReportNamesAbecasInsightReport';
                var dataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSource("NAVREPORT2NAME", dataSource);
                if (formRefs.current['NAVREPORT2FORMAT']) {
                    formRefs.current['NAVREPORT2FORMAT'].instance().option('disabled', false);
                }
            }
            if (v == 'T') {
                var url = 'wm/TransactionDataProfile/GetReportNamesDotNetReport';
                var dataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSource("NAVREPORT2NAME", dataSource);
                if (formRefs.current['NAVREPORT2FORMAT']) {
                    formRefs.current['NAVREPORT2FORMAT'].instance().option('disabled', false);
                }
            }
            if (v == 'A') {
                if (formRefs.current['NAVREPORT2FORMAT']) {
                    formRefs.current['NAVREPORT2FORMAT'].instance().option('disabled', true);
                }
                var url = 'wm/TransactionDataProfile/GetReportNamesAdvanceReportTool';
                var dataSource = new DataSource({
                    store: new createStore({
                        key: 'name',
                        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSourceName("NAVREPORT2NAME", dataSource);
            }
        }

        // NAVREPORT3
        if (formRefs.current['NAVREPORT3STATUS']) {
            const instance = formRefs.current['NAVREPORT3STATUS'].instance();
            let v = instance.option('value');
            if (v == 'I') {
                formRefs.current['NAVREPORT3TEXT'].instance().option('disabled', true);
                formRefs.current['NAVREPORT3TYPE'].instance().option('disabled', true);
                formRefs.current['NAVREPORT3NAME'].instance().option('disabled', true);
                formRefs.current['NAVREPORT3FORMAT'].instance().option('disabled', true);
            }
        }
        if (formRefs.current['NAVREPORT3TYPE']) {
            const instance = formRefs.current['NAVREPORT3TYPE'].instance();
            let v = instance.option('value');
            if (v == 'R') {
                var url = 'wm/TransactionDataProfile/GetReportNamesAbecasInsightReport';
                var dataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSource("NAVREPORT3NAME", dataSource);
                if (formRefs.current['NAVREPORT3FORMAT']) {
                    formRefs.current['NAVREPORT3FORMAT'].instance().option('disabled', false);
                }
            }
            if (v == 'T') {
                var url = 'wm/TransactionDataProfile/GetReportNamesDotNetReport';
                var dataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSource("NAVREPORT3NAME", dataSource);
                if (formRefs.current['NAVREPORT3FORMAT']) {
                    formRefs.current['NAVREPORT3FORMAT'].instance().option('disabled', false);
                }
            }
            if (v == 'A') {
                if (formRefs.current['NAVREPORT3FORMAT']) {
                    formRefs.current['NAVREPORT3FORMAT'].instance().option('disabled', true);
                }
                var url = 'wm/TransactionDataProfile/GetReportNamesAdvanceReportTool';
                var dataSource = new DataSource({
                    store: new createStore({
                        key: 'name',
                        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSourceName("NAVREPORT3NAME", dataSource);
            }
        }
        // NAVREPORT4
        if (formRefs.current['NAVREPORT4STATUS']) {
            const instance = formRefs.current['NAVREPORT4STATUS'].instance();
            let v = instance.option('value');
            if (v == 'I') {
                formRefs.current['NAVREPORT4TEXT'].instance().option('disabled', true);
                formRefs.current['NAVREPORT4TYPE'].instance().option('disabled', true);
                formRefs.current['NAVREPORT4NAME'].instance().option('disabled', true);
                formRefs.current['NAVREPORT4FORMAT'].instance().option('disabled', true);
            }
        }
        if (formRefs.current['NAVREPORT4TYPE']) {
            const instance = formRefs.current['NAVREPORT4TYPE'].instance();
            let v = instance.option('value');
            if (v == 'R') {
                var url = 'wm/TransactionDataProfile/GetReportNamesAbecasInsightReport';
                var dataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSource("NAVREPORT4NAME", dataSource);
                if (formRefs.current['NAVREPORT4FORMAT']) {
                    formRefs.current['NAVREPORT4FORMAT'].instance().option('disabled', false);
                }
            }
            if (v == 'T') {
                var url = 'wm/TransactionDataProfile/GetReportNamesDotNetReport';
                var dataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSource("NAVREPORT4NAME", dataSource);
                if (formRefs.current['NAVREPORT4FORMAT']) {
                    formRefs.current['NAVREPORT4FORMAT'].instance().option('disabled', false);
                }
            }
            if (v == 'A') {
                if (formRefs.current['NAVREPORT4FORMAT']) {
                    formRefs.current['NAVREPORT4FORMAT'].instance().option('disabled', true);
                }
                var url = 'wm/TransactionDataProfile/GetReportNamesAdvanceReportTool';
                var dataSource = new DataSource({
                    store: new createStore({
                        key: 'name',
                        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                loadLookupFromDataSourceName("NAVREPORT4NAME", dataSource);
            }
        }



    }, []);
    const handlMiscellaneousFormLoad = useCallback(() => {
        var serialNumbers = [{ "Rowid": "A", "Code": "Add Serial Numbers" }
            , { "Rowid": "N", "Code": "No Serial Numbers" },
        { "Rowid": "V", "Code": "Validate Serial Numbers" },
        { "Rowid": "I", "Code": "Use Validation Based On RF Flag In Item Master" },
        { "Rowid": "L", "Code": "Use Validation Based On RF Flag In Lot Master" }];
        loadLookupClient("RF_SERIALNUMBERHANDLING", serialNumbers);
        var details = [
            { "Rowid": "N", "Code": "No, Do Not Allow To Enter Default Item Defaults" },
            { "Rowid": "R", "Code": "Yes, Allow To Enter Default Item Details For Receipts Only" },
            { "Rowid": "S", "Code": "Yes, Allow To Enter Default Item Details For Shipments Only" },
            { "Rowid": "B", "Code": "Yes, Allow To Enter Default Item Details For both Receipt and Shipments" }];
        loadLookupClient("ALLOWITEMDETAILS", details);
        var unloadByData = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/ca/Lookup/GetCAActivity`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }], // sort ascending by 'name'
            paginate: true,
            pageSize: 100
        });

        loadLookupFromDataSource("R_CAACTIVITY_UNLOADBY", unloadByData);
        var putawayByData = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/ca/Lookup/GetCAActivity`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSource("R_CAACTIVITY_PUTAWAYBY", putawayByData);
        var checkByData = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/ca/Lookup/GetCAActivity`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSource("R_CAACTIVITY_CHECKBY", checkByData);
        var pickByData = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/ca/Lookup/GetCAActivity`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSource("R_CAACTIVITY_PICKBY", pickByData);
        var loadByData = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/ca/Lookup/GetCAActivity`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSource("R_CAACTIVITY_LOADBY", loadByData);
        var partialQty = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                loadParams: {
                    codeType: function () {
                        return 'S6';
                    }
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSourceName("RFGROUP_PARTIALQTY", partialQty);
        var fullQty = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                loadParams: {
                    codeType: function () {
                        return 'S6';
                    }
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSourceName("RFGROUP_FULLQTY", fullQty);

        var autoSerialNumberOptions = [{ "Rowid": "Y", "Code": "Yes, Auto Generate Serial Numbers based on Quantity" },
        { "Rowid": "N", "Code": "No, Do Not Auto Generate Serial Numbers" }];
        loadLookupClient("AUTOGENERATESERIALNUMBER", autoSerialNumberOptions);
        var useCrateOptions = [{ "Rowid": "Y", "Code": "Yes, Crate Tracking Is Used In Transaction Entry" },
        { "Rowid": "N", "Code": "No, Crate Tracking Is Used In Transaction Entry" }];
        loadLookupClient("USECRATE", useCrateOptions);
        var showPopupOptions = [{ "Rowid": "Y", "Code": "Yes" },
        { "Rowid": "N", "Code": "No" }];
        loadLookupClient("SHOWSERIALNOPOPUP", showPopupOptions);
        var data = [{ "Rowid": "Y", "Code": "Yes, Auto Generate Alternate ID" }
            , { "Rowid": "N", "Code": "No, Do Not Auto Generate Alternate ID" },
        ];
        loadLookupClient("SUBLOT_ALTERNATEIDMETHOD", data);
        data = [{ "Rowid": "A", "Code": "Standard" }
            , { "Rowid": "B", "Code": "Exclude Storage Charges" },
        ];
        loadLookupClient("SCREENTOTALS", data);
        data = [{ "Rowid": "Y", "Code": "Yes, show and allow access" }
            , { "Rowid": "N", "Code": "No, Do not show" },
        ];
        loadLookupClient("TRANSLOCWEIGHT", data);
        data = [{ "Rowid": "Y", "Code": "Yes, calculate estimated weights at pending stage" }
            , { "Rowid": "N", "Code": "No, donot calculate estimated weights at pending stage" },
        ];
        loadLookupClient("ESITMATEDWEIGHT", data);
        data = [{ "Rowid": "Y", "Code": "Yes, calculate estimated weights at pending stage" }
            , { "Rowid": "N", "Code": "No, donot calculate estimated weights at pending stage" },
        ];
        data = [{ "Rowid": "R", "Code": "Yes, For Receipt Transaction Only." }
            , { "Rowid": "N", "Code": "No" },
        ];
        loadLookupClient("GENERATEINSPECTION", data);
        const workUnitData = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/ed/Lookup/GetEdelementcodese`,
                loadParams: {
                    dataelementnum: () => '355',
                    versionid: () => '4010',
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`,
                    };
                }
            }),
            paginate: true,
            pageSize: 100,
            // Sorting is applied after data load
            reshapeOnPush: true,
            postProcess: function (data) {
                return data.sort((a, b) => {
                    const isAlphaA = /^[A-Za-z]/.test(a.name);
                    const isAlphaB = /^[A-Za-z]/.test(b.name);
                    if (isAlphaA && !isAlphaB) return -1;
                    if (!isAlphaA && isAlphaB) return 1;
                    return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
                });
            }
        });

        loadLookupFromDataSourceName("WORKUNITUOM", workUnitData);
        data = [{ "Rowid": "Y", "Code": "Yes, Process dynamically evaluated charges." }
            , { "Rowid": "N", "Code": "No, Do not process dynamically evaluated charges" },
        ];
        loadLookupClient("PROCESSDYNEVALCHARGES", data);
        data = [{ "Rowid": "Y", "Code": "Yes, validate Ordered quantity matches Actual quantity." }
            , { "Rowid": "N", "Code": "No, do not validate" },
        ];
        loadLookupClient("RECEIPTCOMMITORDEREDACTUAL", data);
        data = [{ "Rowid": "Y", "Code": "Yes, allow creating items" }
            , { "Rowid": "N", "Code": "No, do not allow creating items" },
        ];
        loadLookupClient("OTCREATEITEMFLAG", data);
        data = [{ "Rowid": "Y", "Code": "Yes, Lot Code need to be re entered for validation" }
            , { "Rowid": "N", "Code": "No, Lot Code does not need to re enter" },
        ];
        loadLookupClient("LOTCODEENTRYMETHOD", data);
        data = [{ "Rowid": "Y", "Code": "Warn and let user continue" }
            , { "Rowid": "N", "Code": "Proceed with no warning" },
        ];
        loadLookupClient("OVERSELLINGWARNING", data);
        var sublotvarifactions = [{ "Rowid": "Y", "Code": "Yes, For Shipments/Adjustments don't allow adding sublots that are on any open transaction" },
        { "Rowid": "N", "Code": "No" }];
        loadLookupClient("SUBLOTVERIFICATION", sublotvarifactions);


    }, []);
    const handleMiscellaneousChange = useCallback((name, value, e) => {

    }, []);
    const handlePrintFormatChange = useCallback((name, value, e) => {

        if (name == 'NAVREPORT1NAME') {
            const instance = formRefs.current['NAVREPORT1TYPE']?.instance();
            const typeValue = instance?.option('value');
            if (typeValue == 'T') {
                loadLookupDataNetReport(
                    formRefs,
                    "NAVREPORT1FORMAT",
                    `${window._env_.REACT_APP_APIS}/ab/Lookup/GetARTReports`,
                    'name',
                    'name',
                    value
                );
                setSelectBoxValueByDisplay(formRefs, 'NAVREPORT1FORMAT', "name", standard);
            } else {
                loadLookupData(
                    formRefs,
                    "NAVREPORT1FORMAT",
                    `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
                    'name',
                    'name',
                    value
                );
            }
        }

        if (name == 'NAVREPORT2NAME') {
            const instance = formRefs.current['NAVREPORT2TYPE']?.instance();
            const typeValue = instance?.option('value');
            if (typeValue == 'T') {
                loadLookupDataNetReport(
                    formRefs,
                    "NAVREPORT2FORMAT",
                    `${window._env_.REACT_APP_APIS}/ab/Lookup/GetARTReports`,
                    'name',
                    'name',
                    value
                );
                setSelectBoxValueByDisplay(formRefs, 'NAVREPORT2FORMAT', "name", standard);
            } else {
                loadLookupData(
                    formRefs,
                    "NAVREPORT2FORMAT",
                    `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
                    'name',
                    'name',
                    value
                );
            }
        }

        if (name == 'NAVREPORT3NAME') {
            const instance = formRefs.current['NAVREPORT3TYPE']?.instance();
            const typeValue = instance?.option('value');
            if (typeValue == 'T') {
                loadLookupDataNetReport(
                    formRefs,
                    "NAVREPORT3FORMAT",
                    `${window._env_.REACT_APP_APIS}/ab/Lookup/GetARTReports`,
                    'name',
                    'name',
                    value
                );
                setSelectBoxValueByDisplay(formRefs, 'NAVREPORT3FORMAT', "name", standard);
            } else {
                loadLookupData(
                    formRefs,
                    "NAVREPORT3FORMAT",
                    `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
                    'name',
                    'name',
                    value
                );
            }
        }

        if (name == 'NAVREPORT4NAME') {
            const instance = formRefs.current['NAVREPORT4TYPE']?.instance();
            const typeValue = instance?.option('value');
            if (typeValue == 'T') {
                loadLookupDataNetReport(
                    formRefs,
                    "NAVREPORT4FORMAT",
                    `${window._env_.REACT_APP_APIS}/ab/Lookup/GetARTReports`,
                    'name',
                    'name',
                    value
                );
                setSelectBoxValueByDisplay(formRefs, 'NAVREPORT4FORMAT', "name", standard);
            } else {
                loadLookupData(
                    formRefs,
                    "NAVREPORT4FORMAT",
                    `${window._env_.REACT_APP_APIS}/ab/Lookup/GetInsight8ReportFormats`,
                    'name',
                    'name',
                    value
                );
            }
        }

        if (name == 'NAVREPORT1TYPE' && value == 'R') {
            if (formRefs.current['NAVREPORT1FORMAT']) {
                formRefs.current['NAVREPORT1FORMAT'].instance().option('disabled', false);
            }
            var url = 'wm/TransactionDataProfile/GetReportNamesAbecasInsightReport';
            var dataSource = new DataSource({
                store: new createStore({
                    key: 'id',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSource("NAVREPORT1NAME", dataSource);
        }
        if (name == 'NAVREPORT1TYPE' && value == 'T') {
            if (formRefs.current['NAVREPORT1FORMAT']) {
                formRefs.current['NAVREPORT1FORMAT'].instance().option('disabled', false);
            }
            var url = 'wm/TransactionDataProfile/GetReportNamesDotNetReport';
            var dataSource = new DataSource({
                store: new createStore({
                    key: 'id',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSource("NAVREPORT1NAME", dataSource);
        }
        if (name == 'NAVREPORT1TYPE' && value == 'A') {
            if (formRefs.current['NAVREPORT1FORMAT']) {
                formRefs.current['NAVREPORT1FORMAT'].instance().option('disabled', true);
            }
            var url = 'wm/TransactionDataProfile/GetReportNamesAdvanceReportTool';
            var dataSource = new DataSource({
                store: new createStore({
                    key: 'name',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSourceName("NAVREPORT1NAME", dataSource);
        }
        if (name == 'NAVREPORT1STATUS') {
            if (value == 'I') {
                if (formRefs.current['NAVREPORT1TEXT']) {
                    const instance = formRefs.current['NAVREPORT1TEXT'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT1TEXT: '',
                    }));
                }
                if (formRefs.current['NAVREPORT1TYPE']) {
                    const instance = formRefs.current['NAVREPORT1TYPE'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT1TYPE: '',
                    }));
                }
                if (formRefs.current['NAVREPORT1NAME']) {
                    const instance = formRefs.current['NAVREPORT1NAME'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT1NAME: '',
                    }));
                }
                if (formRefs.current['NAVREPORT1FORMAT']) {
                    const instance = formRefs.current['NAVREPORT1FORMAT'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT1FORMAT: '',
                    }));
                }

            } else if (value == 'A') {
                if (formRefs.current['NAVREPORT1TEXT']) {
                    formRefs.current['NAVREPORT1TEXT'].instance().option('disabled', false);
                }
                if (formRefs.current['NAVREPORT1TYPE']) {
                    formRefs.current['NAVREPORT1TYPE'].instance().option('disabled', false);
                }
                if (formRefs.current['NAVREPORT1NAME']) {
                    formRefs.current['NAVREPORT1NAME'].instance().option('disabled', false);
                }
                if (formRefs.current['NAVREPORT1FORMAT']) {
                    formRefs.current['NAVREPORT1FORMAT'].instance().option('disabled', false);
                }
            }
        }

        if (name == 'NAVREPORT2TYPE' && value == 'R') {
            if (formRefs.current['NAVREPORT2FORMAT']) {
                formRefs.current['NAVREPORT2FORMAT'].instance().option('disabled', false);
            }
            var url = 'wm/TransactionDataProfile/GetReportNamesAbecasInsightReport';
            var dataSource = new DataSource({
                store: new createStore({
                    key: 'id',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSource("NAVREPORT2NAME", dataSource);
        }
        if (name == 'NAVREPORT2TYPE' && value == 'T') {
            if (formRefs.current['NAVREPORT2FORMAT']) {
                formRefs.current['NAVREPORT2FORMAT'].instance().option('disabled', false);
            }
            var url = 'wm/TransactionDataProfile/GetReportNamesDotNetReport';
            var dataSource = new DataSource({
                store: new createStore({
                    key: 'id',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSource("NAVREPORT2NAME", dataSource);
        }
        if (name == 'NAVREPORT2TYPE' && value == 'A') {
            if (formRefs.current['NAVREPORT2FORMAT']) {
                formRefs.current['NAVREPORT2FORMAT'].instance().option('disabled', true);
            }
            var url = 'wm/TransactionDataProfile/GetReportNamesAdvanceReportTool';
            var dataSource = new DataSource({
                store: new createStore({
                    key: 'name',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSourceName("NAVREPORT2NAME", dataSource);
        }
        if (name == 'NAVREPORT2STATUS') {
            if (value == 'I') {
                if (formRefs.current['NAVREPORT2TEXT']) {
                    const instance = formRefs.current['NAVREPORT2TEXT'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT2TEXT: '',
                    }));
                }
                if (formRefs.current['NAVREPORT2TYPE']) {
                    const instance = formRefs.current['NAVREPORT2TYPE'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT2TYPE: '',
                    }));
                }
                if (formRefs.current['NAVREPORT2NAME']) {
                    const instance = formRefs.current['NAVREPORT2NAME'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT2NAME: '',
                    }));
                }
                if (formRefs.current['NAVREPORT2FORMAT']) {
                    const instance = formRefs.current['NAVREPORT2FORMAT'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT2FORMAT: '',
                    }));
                }
            } else if (value == 'A') {
                if (formRefs.current['NAVREPORT2TEXT']) {
                    formRefs.current['NAVREPORT2TEXT'].instance().option('disabled', false);
                }
                if (formRefs.current['NAVREPORT2TYPE']) {
                    formRefs.current['NAVREPORT2TYPE'].instance().option('disabled', false);
                }
                if (formRefs.current['NAVREPORT2NAME']) {
                    formRefs.current['NAVREPORT2NAME'].instance().option('disabled', false);
                }
                if (formRefs.current['NAVREPORT2FORMAT']) {
                    formRefs.current['NAVREPORT2FORMAT'].instance().option('disabled', false);
                }
            }
        }


        if (name == 'NAVREPORT3TYPE' && value == 'R') {
            if (formRefs.current['NAVREPORT3FORMAT']) {
                formRefs.current['NAVREPORT3FORMAT'].instance().option('disabled', false);
            }
            var url = 'wm/TransactionDataProfile/GetReportNamesAbecasInsightReport';
            var dataSource = new DataSource({
                store: new createStore({
                    key: 'id',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSource("NAVREPORT3NAME", dataSource);
        }
        if (name == 'NAVREPORT3TYPE' && value == 'T') {
            if (formRefs.current['NAVREPORT3FORMAT']) {
                formRefs.current['NAVREPORT3FORMAT'].instance().option('disabled', false);
            }
            var url = 'wm/TransactionDataProfile/GetReportNamesDotNetReport';
            var dataSource = new DataSource({
                store: new createStore({
                    key: 'id',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSource("NAVREPORT3NAME", dataSource);
        }
        if (name == 'NAVREPORT3TYPE' && value == 'A') {
            if (formRefs.current['NAVREPORT3FORMAT']) {
                formRefs.current['NAVREPORT3FORMAT'].instance().option('disabled', true);
            }
            var url = 'wm/TransactionDataProfile/GetReportNamesAdvanceReportTool';
            var dataSource = new DataSource({
                store: new createStore({
                    key: 'name',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSourceName("NAVREPORT3NAME", dataSource);
        }
        if (name == 'NAVREPORT3STATUS') {
            if (value == 'I') {
                if (formRefs.current['NAVREPORT3TEXT']) {
                    const instance = formRefs.current['NAVREPORT3TEXT'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT3TEXT: '',
                    }));
                }
                if (formRefs.current['NAVREPORT3TYPE']) {
                    const instance = formRefs.current['NAVREPORT3TYPE'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT3TYPE: '',
                    }));
                }
                if (formRefs.current['NAVREPORT3NAME']) {
                    const instance = formRefs.current['NAVREPORT3NAME'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT3NAME: '',
                    }));
                }
                if (formRefs.current['NAVREPORT3FORMAT']) {
                    const instance = formRefs.current['NAVREPORT3FORMAT'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT3FORMAT: '',
                    }));
                }
            } else if (value == 'A') {
                if (formRefs.current['NAVREPORT3TEXT']) {
                    formRefs.current['NAVREPORT3TEXT'].instance().option('disabled', false);
                }
                if (formRefs.current['NAVREPORT3TYPE']) {
                    formRefs.current['NAVREPORT3TYPE'].instance().option('disabled', false);
                }
                if (formRefs.current['NAVREPORT3NAME']) {
                    formRefs.current['NAVREPORT3NAME'].instance().option('disabled', false);
                }
                if (formRefs.current['NAVREPORT3FORMAT']) {
                    formRefs.current['NAVREPORT3FORMAT'].instance().option('disabled', false);
                }
            }
        }

        if (name == 'NAVREPORT4TYPE' && value == 'R') {
            if (formRefs.current['NAVREPORT4FORMAT']) {
                formRefs.current['NAVREPORT4FORMAT'].instance().option('disabled', false);
            }
            var url = 'wm/TransactionDataProfile/GetReportNamesAbecasInsightReport';
            var dataSource = new DataSource({
                store: new createStore({
                    key: 'id',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSource("NAVREPORT4NAME", dataSource);
        }
        if (name == 'NAVREPORT4TYPE' && value == 'T') {
            if (formRefs.current['NAVREPORT4FORMAT']) {
                formRefs.current['NAVREPORT4FORMAT'].instance().option('disabled', false);
            }
            var url = 'wm/TransactionDataProfile/GetReportNamesDotNetReport';
            var dataSource = new DataSource({
                store: new createStore({
                    key: 'id',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSource("NAVREPORT4NAME", dataSource);
        }
        if (name == 'NAVREPORT4TYPE' && value == 'A') {
            if (formRefs.current['NAVREPORT4FORMAT']) {
                formRefs.current['NAVREPORT4FORMAT'].instance().option('disabled', true);
            }
            var url = 'wm/TransactionDataProfile/GetReportNamesAdvanceReportTool';
            var dataSource = new DataSource({
                store: new createStore({
                    key: 'name',
                    loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
            loadLookupFromDataSourceName("NAVREPORT4NAME", dataSource);
        }
        if (name == 'NAVREPORT4STATUS') {
            if (value == 'I') {
                if (formRefs.current['NAVREPORT4TEXT']) {
                    const instance = formRefs.current['NAVREPORT4TEXT'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT4TEXT: '',
                    }));
                }
                if (formRefs.current['NAVREPORT4TYPE']) {
                    const instance = formRefs.current['NAVREPORT4TYPE'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT4TYPE: '',
                    }));
                }
                if (formRefs.current['NAVREPORT4NAME']) {
                    const instance = formRefs.current['NAVREPORT4NAME'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT4NAME: '',
                    }));
                }
                if (formRefs.current['NAVREPORT4FORMAT']) {
                    const instance = formRefs.current['NAVREPORT4FORMAT'].instance();
                    instance.option('disabled', true);
                    instance.option('value', null);
                    setformFields(prevFields => ({
                        ...prevFields,
                        NAVREPORT4FORMAT: '',
                    }));
                }
            } else if (value == 'A') {
                if (formRefs.current['NAVREPORT4TEXT']) {
                    formRefs.current['NAVREPORT4TEXT'].instance().option('disabled', false);
                }
                if (formRefs.current['NAVREPORT4TYPE']) {
                    formRefs.current['NAVREPORT4TYPE'].instance().option('disabled', false);
                }
                if (formRefs.current['NAVREPORT4NAME']) {
                    formRefs.current['NAVREPORT4NAME'].instance().option('disabled', false);
                }
                if (formRefs.current['NAVREPORT4FORMAT']) {
                    formRefs.current['NAVREPORT4FORMAT'].instance().option('disabled', false);
                }
            }
        }

    }, []);
    const handleFocusIn = useCallback((name, e) => {
        let message = '';
        if (name === 'SPLITORDER') {
            message =
                "This option allows a new Receipt Transaction to be created based on the current Receipt Transaction.\n\n" +
                "The new Receipt will contain the inventory from the current Receipt where the Actual Quantity is less than the Order Quantity.\n\n" +
                "The Ordered Quantity for the Current Receipt will change to match the Actual Quantity.\n\n" +
                " A message will be presented when the current Receipt Stage is set to Completed which will give the user the option to continue with the split.";
        }
        if (name === 'ALLOWUSERVALIDATION') {
            message =
                "This option allows you to execute a user-defined SQL validation stored procedure.\n\n" +
                "(spWM_UserValidationOfTransactions) upon saving a transaction header record. This is an EMPTY.\n\n" +
                "stored procedure provided by Argos for users to write their own SQL validation logic.\n\n" +
                "You Must ONLY use SELECT Statements in your SQL Logic.\n\n" +
                "DO NOT use INSERT, UPDATE, OR DELETE statements in your SQL logic.\n\n" +
                "Argos Software Can Provide This Service To You as a Custom Project.";
        }
        if (name === 'ALLOWITEMDETAILS') {
            message =
                "This option allows you to automatically create item detail records for Receipts and Shipment transactions entered in the default profile record.\n\n" +
                "By setting this option to YES, you will enable the Transaction Defaults > Item/Lot tab. On this tab, you can enter the Item Code, Lot Code, and a comment.\n\n" +
                "The Quantity and Location information will still need to be entered in the individual transactions.\n\n" +
                "Note: You MUST have a default CUSTOMER in your profile record to use this option.\n\n" +
                "If the profile is set to automatically create or select a LOT code(s) for receipts or shipments, you will NOT be able to enter default item/lot information.\n\n" +
                "The default SUBLOT information cannot be entered using this screen.";
        }
        if (name === 'R_CAACTIVITY_UNLOADBY') {
            message =
                "This Field is a CA Activity code which is used in item Task Details table.\n\n" +
                "The Activity Description is used for specifying the task description for\n\n" +
                "Unloaded By.";
        }
        if (name === 'R_CAACTIVITY_PUTAWAYBY') {
            message =
                "This Field is a CA Activity code which is used in item Task Details table.\n\n" +
                "The Activity Description is used for specifying the task description for\n\n" +
                "Putaway By.";
        }
        if (name === 'R_CAACTIVITY_CHECKBY') {
            message =
                "This Field is a CA Activity code which is used in item Task Details table.\n\n" +
                "The Activity Description is used for specifying the task description for\n\n" +
                "Check By.";
        }
        if (name === 'R_CAACTIVITY_PICKBY') {
            message =
                "This Field is a CA Activity code which is used in item Task Details table.\n\n" +
                "The Activity Description is used for specifying the task description for\n\n" +
                "Pick By.";
        }
        if (name === 'R_CAACTIVITY_LOADBY') {
            message =
                "This Field is a CA Activity code which is used in item Task Details table.\n\n" +
                "The Activity Description is used for specifying the task description for\n\n" +
                "Loaded By.";
        }
        if (name === 'RFGROUP_PARTIALQTY') {
            message =
                "This Field is used to default a RF Group in to Item Task Details table.\n\n" +
                "When the quantity to be shipped less than the On Hand + in Receiving Quantity\n\n" +
                "then the Task RF Group will be set to this value.";
        }
        if (name === 'RFGROUP_FULLQTY') {
            message =
                "This Field is used to default a RF Group in to Item Task Details table.\n\n" +
                "When the quantity to be shipped is the same as the On Hand + in Receiving Quantity\n\n" +
                "then the Task RF Group will be set to this value.";
        }
        if (name === 'WORKUNITUOM') {
            message =
                "This field is used for entering the default work unit, unit of measure in\n\n" +
                "entering transaction labor tracking information for Receipts, Shipments\n\n" +
                "and Adjustment transactions.";
        }
        if (name === 'IGNORESAMEDAYSHIPTIME') {
            message =
                "This option allows for shipments of lots/sublots on transactions whose time portion of the received shipped date is before the time portion of associated receipts for those same lots/sublots. This applies only when selecting the options to manually select lots and sublots from the option button on the detail tab of shipment transactions and of course when the actual shipped date of the shipment is the same as the receipt.";
        }
       if (name === 'SHIPMENTSONNET_AVL') {
            message ="This option performs two separate checks upon exiting the transaction. First, it will verify the ordered quantity is the same as the actual quantity when the transaction is in the Ready or Completed stages. Second, it will verify the applicable ordered or actual quantity is less than or equal to its' net available quantity less any pending receipts."
        }
       if (name === 'ALLOWBLANKLOCATIONS') {
            message =`This Field configures the option to allow you to validate the existence of blank locations in the transaction. The Validation will only applicable to the Transactions with "Completed" Stage.
             If you choose the option to validate during transaction entry process, the validation will occur when you exit the transaction. If you choose the validation during the transaction commit, the following message will display if a blank location records exits in the transactions.
            "Commit Process Failed Due to Data Errors - Use Print Errors Button to View Report".`
        }
        if (message) {
            notify({ message, width: 600, height: 200 }, 'warning', 6000);
        }
    }, []);

    return (
        <>
            <div>
                <div className="row dataEntryMainPage">
                    <div className="col-md-12 main-page">
                        <div id="accordion">

                            <LoadPanel
                                shadingColor="rgba(0,0,0,0.4)"
                                position={position}
                                onHiding={hideLoadPanel}
                                visible={loadPanelVisible}
                                showIndicator={true}
                                shading={true}
                                showPane={true}
                                hideOnOutsideClick={false}
                            />
                            <form onSubmit={(e) => handleFormSubmit(e)}>
                                <Toolbar className="header">
                                    <Item location="before">
                                        <div className="title">
                                            <h6
                                                style={{
                                                    color: window._env_.Color2,
                                                    marginLeft: '12px'
                                                }}
                                            >
                                                Enter Transaction Profiles
                                            </h6>
                                        </div>
                                    </Item>
                                    <Item location="after">
                                        <Button
                                            text="Save"
                                            useSubmitBehavior={true}
                                            type="default"
                                            className="accordianButton"
                                        />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton"
                                            disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'}
                                            text="Transaction Defaults" type="default" onClick={goToDefaultTransaction}>
                                        </Button>
                                    </Item>
                                    <Item location="after">
                                        <Button
                                            text="Delete"
                                            type="default"
                                            className="accordianButton"
                                            onClick={deleteRecords}
                                            disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'}
                                        />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={goBack} text="Back" />
                                    </Item>

                                </Toolbar>
                                <div className="AccordionItemBody">
                                    <TabPanel deferRendering={props.id ? true : false} className="TabpanelContainer">
                                        <TabItem title="Primary">

                                            <FormField
                                                currrentUser={currentUser}
                                                layoutId='A017A536-2087-4A1F-B4AD-B82AB8DB4BEF'
                                                layoutName='WMTransactionprofilePrimayForm'
                                                defaultFormSchema={PrimaryLayout}
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                handleFieldValueChange={handleFieldChange}
                                                handleSelectedItemChange={handleSelectionChange}
                                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                                formRefs={formRefs}
                                                onFormLoad={handlePrimaryFormLoad}
                                                handleFocusItemIn={handleFocusIn}
                                            />

                                        </TabItem>
                                        <TabItem title="Header">

                                            <FormField
                                                currrentUser={currentUser}
                                                layoutId='774D19E6-63CA-47C5-AEE7-0543E624C0A0'
                                                layoutName='WMTransactionprofilePrimayForm'
                                                defaultFormSchema={HeaderTabLayout}
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                handleFieldValueChange={handleFieldChange}
                                                handleSelectedItemChange={handleSelectionChange}
                                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                                formRefs={formRefs}
                                                onFormLoad={handleHeaderFormLoad}
                                                handleFocusItemIn={handleFocusIn}
                                            />

                                        </TabItem>
                                        <TabItem title="Details">
                                            <FormField
                                                currrentUser={currentUser}
                                                layoutId='AC028D08-B2EE-4217-B510-8B132D65212E'
                                                layoutName='WMTransactionprofileDetailForm'
                                                defaultFormSchema={DetailsLayout}
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                handleFieldValueChange={handleFieldChange}
                                                handleSelectedItemChange={handleSelectionChange}
                                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                                formRefs={formRefs}
                                                onFormLoad={handleDetailsFormLoad}
                                                handleFocusItemIn={handleFocusIn}
                                            />

                                        </TabItem>
                                        <TabItem title="Repack">
                                            <FormField
                                                currrentUser={currentUser}
                                                layoutId='E988045A-0857-4516-8AA6-04247456BF06'
                                                layoutName='WMTransactionprofilePrimayForm'
                                                defaultFormSchema={RepackLayout}
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                handleFieldValueChange={handleFieldChange}
                                                handleSelectedItemChange={handleSelectionChange}
                                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                                formRefs={formRefs}
                                                onFormLoad={handlRepackFormLoad}
                                                handleFocusItemIn={handleFocusIn}
                                            />
                                        </TabItem>
                                        <TabItem title="Miscellaneous">
                                            <FormField
                                                currrentUser={currentUser}
                                                layoutId='f059a441-fb01-4f0b-8ee0-0ccc36cd84e7'
                                                layoutName='WMTransactionprofileMiscellaneousForm'
                                                defaultFormSchema={MiscellaneousTabLayout}
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                handleFieldValueChange={handleMiscellaneousChange}
                                                handleSelectedItemChange={handleSelectionChange}
                                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                                formRefs={formRefs}
                                                handleFocusItemIn={handleFocusIn}
                                                onFormLoad={handlMiscellaneousFormLoad}
                                            />
                                        </TabItem>
                                        <TabItem title="PRINT FORMATS">
                                            <FormField
                                                currrentUser={currentUser}
                                                layoutId='E62D8622-FD3F-421B-8C92-E84FC8A4A992'
                                                layoutName='WMTransactionprofilePrintFormatTabLayout'
                                                defaultFormSchema={PrintFormatTabLayout}
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                handleFieldValueChange={handlePrintFormatChange}
                                                handleSelectedItemChange={handleSelectionChange}
                                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                                formRefs={formRefs}
                                                handleFocusItemIn={handleFocusIn}
                                                onFormLoad={handlPrintFormatFormLoad}
                                            />
                                        </TabItem>
                                        {/* <TabItem title="Dimensions">
                                            
                                        </TabItem>
                                        <TabItem title="User Defined">
                                            
                                        </TabItem>
                                        <TabItem title="Proximity" disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'} >
                                           
                                        </TabItem> */}
                                    </TabPanel>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTab);